(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero__audio-toggle').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var wrapper = btn.parentElement;
      var video = wrapper ? wrapper.querySelector('video') : null;
      if (video) {
        video.muted = !video.muted;
        btn.setAttribute('data-muted', String(video.muted));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plekify-homepage-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('plekify-proposal-form-{{ section.id }}');
    if (!form) return;

    var feedback = form.querySelector('.plekify-cta__feedback');
    var submitBtn = form.querySelector('.plekify-cta__submit');
    var originalText = submitBtn ? submitBtn.textContent : 'Get a proposal';
    var successPanel = document.getElementById('plekify-cta-success-{{ section.id }}');

    function showMessage(message, isError) {
      if (!feedback) return;
      feedback.textContent = message;
      feedback.classList.remove('plekify-cta__feedback--success', 'plekify-cta__feedback--error');
      feedback.classList.add(isError ? 'plekify-cta__feedback--error' : 'plekify-cta__feedback--success');
    }

    function showSuccessState() {
      if (form) form.setAttribute('hidden', '');
      if (successPanel) successPanel.removeAttribute('hidden');
      try {
        var finalCta = document.getElementById('final-cta');
        if (finalCta) finalCta.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {}
    }

    function maybeShowSuccessFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        if (params.get('proposal') === 'submitted' || params.get('waitlist') === 'submitted') {
          showSuccessState();
        }
      } catch (e) {}
    }

    maybeShowSuccessFromUrl();

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      // Honeypot check
      var honeypot = form.querySelector('input[name="website"]');
      if (honeypot && honeypot.value) {
        showMessage('Thanks. Matthew will be in touch within 24 hours.', false);
        return;
      }

      var required = form.querySelectorAll('[required]');
      var valid = true;
      required.forEach(function (field) {
        if (!field.value.trim()) {
          valid = false;
          field.setAttribute('aria-invalid', 'true');
        } else {
          field.setAttribute('aria-invalid', 'false');
        }
      });

      if (!valid) {
        showMessage('Please complete all required fields.', true);
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';
      }

      var data = {};
      var formData = new FormData(form);
      formData.forEach(function (value, key) {
        data[key] = value;
      });

      fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (response) {
          if (response.ok) {
            showSuccessState();
            form.reset();
          } else {
            throw new Error('Server returned ' + response.status);
          }
        })
        .catch(function () {
          showMessage('Something went wrong. Please email matt@plekify.com directly.', true);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plekify-operator-dossier"] && !Shopify.designMode) return;
  try {
    
(() => {
  const DOSSIER_SELECTOR = '.plekify-dossier[data-itinerary-identifier]';

  // Shared reader-facing labels (snippets/plekify-itinerary-labels.liquid) — deck
  // 'itinerary-documents-labels-v1'. Degrades to raw values if the deck is absent.
  const LABELS = window.PLK_ITIN_LABELS || { deck: { labels: {}, strings: {}, markers: {} }, label: (v) => String(v ?? ''), text: (v) => String(v ?? ''), marker: () => '' };

  // Utility functions
  const text = (v) => String(v ?? '').replace(/\s+/g, ' ').trim();
  const escapeHtml = (v) => String(v ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  // Block-aware HTML-to-text: a separator is inserted between block elements so
  // "…</strong></p><p>Next…" never glues into one word (F2).
  const BLOCK_SELECTOR = 'p,div,li,h1,h2,h3,h4,h5,h6,ul,ol,table,tr,td,th,blockquote,figcaption,section,header,footer,pre';
  const stripHtml = (v) => { const r = String(v ?? ''); if (!r) return ''; if (typeof DOMParser === 'function' && /<[^>]+>/.test(r)) { const d = new DOMParser().parseFromString('<div>'+r+'</div>','text/html'); d.body.querySelectorAll('br').forEach((br) => br.replaceWith(' ')); d.body.querySelectorAll(BLOCK_SELECTOR).forEach((el) => el.insertAdjacentText('afterend', ' ')); return text(d.body.textContent||''); } return text(r); };
  const hasOwn = (o,k) => Object.prototype.hasOwnProperty.call(o,k);
  const unwrap = (v) => (v && typeof v === 'object' && hasOwn(v,'value')) ? unwrap(v.value) : v;
  const normalizeKey = (k) => text(k).toLowerCase().replace(/[\s_-]+/g, '');
  const readKey = (o, k) => { if (!o || typeof o !== 'object') return undefined; if (hasOwn(o,k)) return unwrap(o[k]); const n = normalizeKey(k); for (const c of Object.keys(o)) { if (normalizeKey(c) === n) return unwrap(o[c]); } return undefined; };
  const isPresent = (v) => { if (v === null || v === undefined) return false; if (typeof v === 'number') return Number.isFinite(v); if (typeof v === 'boolean') return true; if (Array.isArray(v)) return v.length > 0; if (typeof v === 'object') return Object.keys(v).length > 0; return text(v) !== ''; };
  const pick = (o, keys, fb = null) => { for (const k of keys) { const v = readKey(o,k); if (isPresent(v)) return v; } return fb; };
  const toArray = (v) => { const u = unwrap(v); if (Array.isArray(u)) return u; if (u == null) return []; return [u]; };
  const pickNumber = (o, keys, fb = NaN) => { const v = pick(o, keys, fb); const p = parseFloat(String(v ?? '').replace(/[^0-9.-]/g,'')); return isFinite(p) ? p : fb; };
  // Fleet date pattern (store_overrides/travel_2022/assets/plk-itin-run-of-show.js:64-69):
  // source dates are naive local ISO ("2026-06-28T00:00:00") — parse the date-only part and
  // anchor it at NOON UTC so the UTC formatters below never shift a day at UTC+X.
  const parseDate = (v) => { const r = text(v); if (!r) return null; const iso = /^\d{4}-\d{2}-\d{2}/.test(r) ? r.slice(0, 10) + 'T12:00:00Z' : r; const d = new Date(iso); return isNaN(d.getTime()) ? null : d; };
  const addDays = (date, days) => {
    const base = date instanceof Date ? date : parseDate(date);
    if (!base) return null;
    const next = new Date(base.getTime());
    next.setUTCDate(next.getUTCDate() + days);
    return next;
  };
  const utcDateFmt = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
  const formatDate = (v) => {
    const d = v instanceof Date ? v : parseDate(v);
    if (!d) return '';
    return utcDateFmt.format(d).replace('Sept', 'Sep');
  };
  const formatDateRange = (start, end) => {
    const from = formatDate(start);
    const to = formatDate(end);
    if (!from) return to;
    if (!to || to === from) return from;
    return `${from} – ${to}`;
  };
  // Literal unified with the base (customer) view on the same page family, whose data
  // strings read `ZAR 265,000` (ISO code + comma grouping, zero decimals). en-US grouping
  // plus currencyDisplay:'code' reproduces that for any ISO code; en-ZA renders the narrow
  // symbol `R` with U+00A0 grouping (T4 post-deploy audit section 7.1).
  const formatCurrency = (amount, currency = 'ZAR') => {
    const num = parseFloat(String(amount ?? '').replace(/[^0-9.-]/g, ''));
    if (!isFinite(num)) return '--';
    const raw = text(currency).toUpperCase();
    const code = /^[A-Z]{3}$/.test(raw) ? raw : 'ZAR';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: code, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(num);
  };
  const getDossierView = (data) => pick(data, ['dossier_view', 'dossierView'], {}) || {};
  const getCustomerView = (data) => pick(data, ['customer_view', 'customerView'], {}) || {};
  const joinGuestValues = (values = []) => values.map((value) => text(value)).filter(Boolean).join(', ');
  // Adversarial-eval D2 render guards — display only, never rewrite source data.
  // (a) A party string of digits/spaces only ("3 3") is corrupted source data, not a name,
  //     so fall back to the traveller count, then to a neutral placeholder.
  // (b) A raw internal UUID must never surface in the masthead ref strip.
  const displayParty = (data, rawParty) => {
    const party = text(rawParty);
    if (party && !/^[\d\s]+$/.test(party)) return party;
    const partyOverview = pick(getCustomerView(data), ['party_overview', 'partyOverview'], {}) || {};
    const tripSummary = pick(data, ['trip_summary', 'tripSummary'], {}) || {};
    const travellers = pickNumber(partyOverview, ['total_travellers', 'totalTravellers'], NaN) ||
      pickNumber(tripSummary, ['total_travellers', 'totalTravellers'], NaN);
    return travellers > 0 ? `${travellers} travellers` : 'Party details on request';
  };
  const displayRef = (value) => {
    const ref = text(value);
    if (!ref) return '';
    return /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-/.test(ref) ? `Ref ${ref.slice(0, 8).toUpperCase()}` : ref;
  };
  const buildMastheadMeta = (data) => {
    const executiveSummary = pick(getDossierView(data), ['executive_summary', 'executiveSummary'], {}) || {};
    const customerView = getCustomerView(data);
    const hero = pick(customerView, ['hero'], {}) || {};
    const startDate = text(pick(hero, ['start_date', 'startDate'])) || text(pick(data, ['start_date', 'startDate']));
    const endDate = text(pick(hero, ['end_date', 'endDate'])) || text(pick(data, ['end_date', 'endDate']));
    const partyLabel = displayParty(data, text(pick(executiveSummary, ['party_label', 'partyLabel'])) || text(pick(pick(customerView, ['party_overview', 'partyOverview'], {}), ['party_label', 'partyLabel'])));
    const referenceNumber = displayRef(text(pick(executiveSummary, ['itinerary_id', 'itineraryId'])) || text(pick(data, ['identifier', 'itinerary_id', 'itineraryId', 'reference_number', 'referenceNumber'])));
    return [formatDateRange(startDate, endDate), partyLabel, referenceNumber].filter(Boolean).join(' · ');
  };
  const buildRoutingLine = (data) => {
    const routeSummary = toArray(pick(getCustomerView(data), ['route_summary', 'routeSummary']));
    if (routeSummary.length) {
      return routeSummary
        .map((segment) => text(pick(segment, ['location_label', 'locationLabel', 'accommodation'])))
        .filter(Boolean)
        .join(' → ');
    }
    const segments = toArray(pick(data, ['segments', 'Segments', 'legs', 'Legs']));
    return segments
      .map((segment) => {
        const items = toArray(pick(segment, ['items', 'Items']));
        const accommodation = items.find((item) => pick(item, ['item_type', 'itemType']) === 'accommodation');
        return text(pick(accommodation, ['name']) || pick(segment, ['name', 'title', 'accommodation_name']));
      })
      .filter(Boolean)
      .join(' → ');
  };

  // Fetch from API
  // Fail-closed identity guard: a payload whose envelope declares a different
  // itinerary_identifier than the one requested is never rendered.
  const fetchCanonicalSource = async (identifier) => {
    const id = text(identifier);
    if (!id) return null;
    const url = new URL('/apps/plekify/api/itinerary', window.location.origin);
    url.searchParams.set('identifier', id);
    url.searchParams.set('v', String(Date.now()));
    const StaffKey = window.PlekifyStaffKey || { get: () => '', apply: (h) => h || {}, ensure: () => Promise.resolve('') };
    const request = () => fetch(url.toString(), {
      cache: 'no-store',
      credentials: 'include',
      headers: StaffKey.apply({})
    });
    const readResponse = async () => {
      const res = await request();
      if (res.status === 401 || res.status === 403) throw new Error('AUTH');
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const payload = await res.json();
      if (!payload.success) throw new Error(payload.message || 'API error');
      return payload;
    };
    let response = await readResponse();
    // Anonymous callers receive a customer projection (no dossier_view marker).
    // Staff surface: ask once for the session-scoped key, then retry ONCE.
    const hasFullPayload = (payload) => {
      const d = payload && payload.data;
      return Boolean(d && (d.dossier_view || (d.itinerary && d.itinerary.dossier_view)));
    };
    if (!hasFullPayload(response) && !StaffKey.get()) {
      const key = await StaffKey.ensure('operator-dossier');
      if (key) response = await readResponse();
    }
    const declared = text(pick(response.data || {}, ['itinerary_identifier', 'itineraryIdentifier']));
    if (declared && declared.toLowerCase() !== id.toLowerCase()) return null;
    const itinerary = response.data.itinerary;
    return itinerary && typeof itinerary === 'object' ? itinerary : response.data;
  };

  // Flag type detection
  const detectFlagType = (txt, category) => {
    if (category) {
      const cat = text(category).toLowerCase();
      if (cat.includes('diet')) return 'DIETARY';
      if (cat.includes('medical') || cat.includes('physical')) return 'MEDICAL';
      if (cat.includes('mobility')) return 'MOBILITY';
    }
    const t = (txt || '').toLowerCase();
    if (/allerg|anaphyla/.test(t)) return 'ALLERGY';
    if (/gluten|coeliac|celiac|dietary|vegan|vegetarian|halal|kosher|food|meal/.test(t)) return 'DIETARY';
    if (/mobility|wheelchair|accessible|walking|knee|step/.test(t)) return 'MOBILITY';
    if (/diabetes|medical|health|medication|condition/.test(t)) return 'MEDICAL';
    if (/malaria|prophylaxis/.test(t)) return 'MEDICAL';
    if (/flight|transfer|transit|airport|vehicle|charter|logistics/.test(t)) return 'LOGISTICS';
    if (/proposal|ring|surprise|celebration|confidential|secret|anniversary/.test(t)) return 'CONFIDENTIAL';
    return 'OPERATIONS';
  };

  const flagColor = (severity) => {
    if (severity === 'critical' || severity === 'hard') return 'var(--plk-block)';
    if (severity === 'high') return 'var(--plk-warn)';
    return '#737373';
  };

  // Render Executive Summary
  const renderSummary = (data) => {
    const dossierView = getDossierView(data);
    const executiveSummary = pick(dossierView, ['executive_summary', 'executiveSummary'], {}) || {};
    const commercialPositioning = pick(executiveSummary, ['commercial_positioning', 'commercialPositioning'], {}) || {};
    const customerView = getCustomerView(data);
    const hero = pick(customerView, ['hero'], {}) || {};
    const startDate = text(pick(hero, ['start_date', 'startDate'])) || text(pick(data, ['start_date', 'startDate']));
    const endDate = text(pick(hero, ['end_date', 'endDate'])) || text(pick(data, ['end_date', 'endDate']));
    const nights = pickNumber(hero, ['night_count', 'nightCount'], pickNumber(data, ['nights', 'Nights'], 0));
    const partyLabel = displayParty(data, text(pick(executiveSummary, ['party_label', 'partyLabel'])) || text(pick(pick(customerView, ['party_overview', 'partyOverview'], {}), ['party_label', 'partyLabel'])));
    const status = text(pick(executiveSummary, ['status'])) || 'draft';
    const itineraryId = text(pick(executiveSummary, ['itinerary_id', 'itineraryId'])) || text(pick(data, ['identifier', 'itinerary_id', 'itineraryId'])) || '--';
    const adultRateAverage = pickNumber(commercialPositioning, ['adult_rate_average', 'adultRateAverage'], NaN);
    const fixedLogisticsTotal = pickNumber(commercialPositioning, ['fixed_logistics_total', 'fixedLogisticsTotal'], NaN);
    const arcSummary = text(pick(executiveSummary, ['narrative_arc_summary', 'narrativeArcSummary'])) || '--';

    return `
      <div class="plekify-dossier__summary-item">
        <span class="plekify-dossier__summary-label">Itinerary</span>
        <span class="plekify-dossier__summary-value">${escapeHtml(itineraryId)}</span>
      </div>
      <div class="plekify-dossier__summary-item">
        <span class="plekify-dossier__summary-label">Party</span>
        <span class="plekify-dossier__summary-value">${escapeHtml(partyLabel)}</span>
      </div>
      <div class="plekify-dossier__summary-item">
        <span class="plekify-dossier__summary-label">Status</span>
        <span class="plekify-dossier__summary-value">${escapeHtml(LABELS.label(status))}</span>
      </div>
      <div class="plekify-dossier__summary-item">
        <span class="plekify-dossier__summary-label">Travel Window</span>
        <span class="plekify-dossier__summary-value">${escapeHtml(formatDateRange(startDate, endDate))}</span>
      </div>
      <div class="plekify-dossier__summary-item">
        <span class="plekify-dossier__summary-label">Total Nights</span>
        <span class="plekify-dossier__summary-value">${nights || '--'}</span>
      </div>
      <div class="plekify-dossier__summary-item">
        <span class="plekify-dossier__summary-label">All-in per traveller</span>
        <span class="plekify-dossier__summary-value">${formatCurrency(adultRateAverage)}</span>
      </div>
      <div class="plekify-dossier__summary-item">
        <span class="plekify-dossier__summary-label">Fixed Logistics</span>
        <span class="plekify-dossier__summary-value">${formatCurrency(fixedLogisticsTotal)}</span>
      </div>
      <div class="plekify-dossier__summary-item">
        <span class="plekify-dossier__summary-label">Narrative Arc</span>
        <span class="plekify-dossier__summary-value">${escapeHtml(LABELS.text(arcSummary))}</span>
      </div>
    `;
  };

  // Render Journey DNA
  const renderJourneyDna = (data) => {
    const dossierView = getDossierView(data);
    const narrativeArc = pick(dossierView, ['narrative_arc', 'narrativeArc'], {}) || {};
    const chapters = toArray(pick(narrativeArc, ['chapters']));
    if (!chapters.length) return '';

    const cards = chapters.map((chapter, idx) => {
      const name = text(pick(chapter, ['chapter_name', 'chapterName'])) || `Chapter ${idx + 1}`;
      const description = text(pick(chapter, ['emotional_function', 'emotionalFunction']));
      const designNotes = text(pick(chapter, ['design_notes', 'designNotes']));
      const dayRange = text(pick(chapter, ['days']));
      return `
        <div class="plekify-dossier__dna-card">
          <p class="plekify-dossier__dna-priority">${escapeHtml(dayRange || `Chapter ${idx + 1}`)}</p>
          <h3 class="plekify-dossier__dna-name">${escapeHtml(name)}</h3>
          ${description ? `<p class="plekify-dossier__dna-description">${escapeHtml(description)}</p>` : ''}
          ${designNotes ? `<p class="plekify-dossier__dna-description">${escapeHtml(designNotes)}</p>` : ''}
        </div>
      `;
    }).join('');

    return `
      <div class="plekify-dossier__section-heading">
        <div class="plekify-dossier__section-heading-row">
          <h2>Narrative Arc</h2>
          <span class="plekify-dossier__section-type">Strategic Story Design</span>
        </div>
        <p>${escapeHtml(LABELS.text(text(pick(narrativeArc, ['arc_summary', 'arcSummary'])) || 'How the itinerary is meant to build emotionally and commercially across chapters.'))}</p>
      </div>
      <div class="plekify-dossier__dna-grid">${cards}</div>
    `;
  };

  // Render Operational Flags from guest constraints
  const renderFlags = (data) => {
    const flags = [];
    const guestRegistry = pick(data, ['guest_registry', 'guestRegistry'], {});
    const guests = toArray(pick(guestRegistry, ['guests', 'Guests'])) || toArray(pick(data, ['travellers', 'travelers', 'guests']));

    guests.forEach(guest => {
      const personalInfo = pick(guest, ['personal_info', 'personalInfo'], guest);
      const guestName = text(pick(personalInfo, ['full_name', 'fullName', 'name']));
      const requirements = pick(guest, ['requirements'], {});

      // Dietary constraints
      toArray(pick(requirements, ['dietary'])).forEach(req => {
        if (text(req)) {
          flags.push({ text: text(req), severity: 'high', type: 'DIETARY', guest: guestName });
        }
      });

      // Medical/Physical constraints
      toArray(pick(requirements, ['medical_physical', 'medicalPhysical'])).forEach(req => {
        if (text(req)) {
          flags.push({ text: text(req), severity: 'critical', type: 'MOBILITY', guest: guestName });
        }
      });
    });

    // Also check top-level operational_flags
    const topFlags = toArray(pick(data, ['operational_flags', 'operationalFlags', 'flags']));
    topFlags.forEach(flag => {
      const flagText = text(pick(flag, ['text', 'description', 'message']));
      const severity = text(pick(flag, ['severity', 'level'])).toLowerCase();
      if (flagText) {
        flags.push({ text: flagText, severity: severity || 'normal', type: detectFlagType(flagText), guest: '' });
      }
    });

    if (!flags.length) return '';

    const flagsHtml = flags.map(flag => {
      const color = flagColor(flag.severity);
      const sevClass = flag.severity === 'critical' || flag.severity === 'hard' ? 'plekify-dossier__flag--critical' : flag.severity === 'high' ? 'plekify-dossier__flag--high' : '';
      return `
        <div class="plekify-dossier__flag ${sevClass}">
          <div class="plekify-dossier__flag-content">
            <p class="plekify-dossier__flag-type" style="color:${color}">${flag.type}</p>
            <p class="plekify-dossier__flag-text">${escapeHtml(flag.text)}</p>
            ${flag.guest ? `<p class="plekify-dossier__flag-guest">${escapeHtml(flag.guest)}</p>` : ''}
          </div>
        </div>
      `;
    }).join('');

    return `
      <div class="plekify-dossier__section-heading">
        <div class="plekify-dossier__section-heading-row">
          <h2>Operational Flags</h2>
          <span class="plekify-dossier__section-type">Critical Alerts</span>
        </div>
        <p>Guest constraints and requirements requiring property confirmation</p>
      </div>
      <div class="plekify-dossier__flags-grid">${flagsHtml}</div>
    `;
  };

  // Render Confidential Arrangements
  const renderConfidential = (data) => {
    const opsView = pick(data, ['ops_view', 'opsView'], {}) || {};
    const entries = toArray(pick(opsView, ['confidential_events', 'confidentialEvents']));
    if (!entries.length) return '';

    const items = entries.map(entry => {
      const oneLine = escapeHtml(text(pick(entry, ['event_type', 'eventType', 'summary'])) || 'Confidential arrangement');
      const fullBrief = escapeHtml(text(toArray(pick(entry, ['logistics_checklist', 'logisticsChecklist'])).join(' · ')));
      const property = escapeHtml(joinGuestValues(pick(entry, ['staff_access_list', 'staffAccessList'], [])));
      const triggerDay = escapeHtml(text(pick(entry, ['date'])));
      const parties = escapeHtml(joinGuestValues(pick(entry, ['participants'], [])));
      return `
        <div class="plekify-dossier__confidential-item">
          <h4 class="plekify-dossier__confidential-title">${oneLine}</h4>
          ${fullBrief ? `<p class="plekify-dossier__confidential-body">${fullBrief}</p>` : ''}
          <p class="plekify-dossier__confidential-meta">
            ${property ? `<span><strong>Staff access:</strong> ${property}</span>` : ''}
            ${triggerDay ? `<span><strong>Date:</strong> ${triggerDay}</span>` : ''}
            ${parties ? `<span><strong>Participants:</strong> ${parties}</span>` : ''}
          </p>
        </div>
      `;
    }).join('');

    return `
      <div class="plekify-dossier__confidential-block">
        <h3 class="plekify-dossier__confidential-heading">Confidential Arrangements — Do Not Share With Guest</h3>
        ${items}
      </div>
    `;
  };

  // Render Guest Registry
  const renderGuestRegistry = (data) => {
    const dossierView = getDossierView(data);
    const guests = toArray(pick(dossierView, ['guest_constraint_matrix', 'guestConstraintMatrix']));
    if (!guests.length) return '';

    const cards = guests.map(guest => {
      const name = text(pick(guest, ['name']));
      const role = text(pick(guest, ['role']));
      const dietary = toArray(pick(guest, ['dietary'])).map(text).filter(Boolean);
      const mobility = toArray(pick(guest, ['mobility'])).map(text).filter(Boolean);
      const requests = toArray(pick(guest, ['special_requests', 'specialRequests'])).map(text).filter(Boolean);
      const interests = toArray(pick(guest, ['interests'])).map(text).filter(Boolean);

      const allConstraints = [
        ...dietary.map((entry) => ({ text: entry, severity: 'high', category: 'Dietary' })),
        ...mobility.map((entry) => ({ text: entry, severity: 'hard', category: 'Mobility' })),
        ...requests.map((entry) => ({ text: entry, severity: 'preference', category: 'Special request' })),
      ];

      const interestsHtml = interests.length ? `
        <div class="plekify-dossier__guest-section">
          <p class="plekify-dossier__guest-section-title">Interests</p>
          <div class="plekify-dossier__guest-interests">
            ${interests.map(i => `<span class="plekify-dossier__guest-interest-pill">${escapeHtml(i)}</span>`).join('<span class="plekify-dossier__chip-sep">, </span>')}
          </div>
        </div>
      ` : '';

      const constraintsHtml = allConstraints.length ? `
        <div class="plekify-dossier__guest-section">
          <p class="plekify-dossier__guest-section-title">Constraints & Requirements</p>
          ${allConstraints.map(c => `
            <div class="plekify-dossier__guest-constraint">
              <span class="plekify-dossier__constraint-severity plekify-dossier__constraint-severity--${c.severity}">${escapeHtml(LABELS.label(c.severity))}</span>
              <span class="plekify-dossier__constraint-text">${escapeHtml(c.text)}</span>
            </div>
          `).join('')}
        </div>
      ` : '';

      return `
        <div class="plekify-dossier__guest-card">
          <div class="plekify-dossier__guest-header">
            <h3 class="plekify-dossier__guest-name">${escapeHtml(name)}</h3>
            <div class="plekify-dossier__guest-meta">
              ${role ? `<span>${escapeHtml(role)}</span>` : ''}
            </div>
          </div>
          ${interestsHtml}
          ${constraintsHtml}
        </div>
      `;
    }).join('');

    return `
      <div class="plekify-dossier__section-heading">
        <div class="plekify-dossier__section-heading-row">
          <h2>Constraint Matrix</h2>
          <span class="plekify-dossier__section-type">${guests.length} Guests</span>
        </div>
        <p>Operator-facing constraint matrix showing dietary, mobility, and request logic per traveller.</p>
      </div>
      <div class="plekify-dossier__guest-grid">${cards}</div>
    `;
  };

  // Render Property Selection Rationale
  const renderPropertyRationale = (data) => {
    const dossierView = getDossierView(data);
    const customerRationales = toArray(pick(getCustomerView(data), ['property_rationales', 'propertyRationales']));
    const rationaleCards = toArray(pick(dossierView, ['property_selection_logic', 'propertySelectionLogic']))
      .map((segment) => {
        const segmentId = text(pick(segment, ['segment_id', 'segmentId']));
        const propertyName = text(pick(segment, ['property_name', 'propertyName']));
        const pinId = pick(segment, ['pin_id', 'pinId']);
        const locationStr = text(pick(segment, ['website_url', 'websiteUrl'])) || text(pick(segment, ['social_proof_density', 'socialProofDensity']));
        const confidence = pickNumber(segment, ['overall_confidence', 'overallConfidence'], NaN);
        const googleRating = pickNumber(segment, ['google_rating', 'googleRating'], NaN);
        const constraintChecks = toArray(pick(segment, ['constraint_checks', 'constraintChecks']));
        const rationaleMatch = customerRationales.find((entry) => text(pick(entry, ['segment_id', 'segmentId'])) === segmentId);
        const rationaleText = text(pick(rationaleMatch, ['rationale']));
        const metaBits = [
          Number.isFinite(googleRating) ? `Google ${googleRating.toFixed(1)}` : '',
          Number.isFinite(confidence) ? `Confidence ${Math.round(confidence * 100)}%` : '',
        ].filter(Boolean).join(' · ');
        return `
        <div class="plekify-dossier__rationale-card">
          <div class="plekify-dossier__rationale-header">
            <div>
              <h3 class="plekify-dossier__rationale-property">${escapeHtml(propertyName)}</h3>
              <p class="plekify-dossier__rationale-meta">${escapeHtml(metaBits || locationStr || '--')}</p>
            </div>
            ${pinId ? `<span class="plekify-dossier__rationale-pin">PIN ${pinId}</span>` : ''}
          </div>
          ${rationaleText ? `<p class="plekify-dossier__rationale-text">${escapeHtml(rationaleText)}</p>` : ''}
          ${locationStr && (!rationaleText || metaBits) ? `<p class="plekify-dossier__rationale-text">${escapeHtml(locationStr)}</p>` : ''}
          ${constraintChecks.length ? `
            <div class="plekify-dossier__rationale-constraints">
              ${constraintChecks.map(check => `
                <div class="plekify-dossier__constraint-check">
                  <span class="plekify-dossier__constraint-check-icon">${pick(check, ['status']) === 'pass' ? LABELS.marker('check.met') : LABELS.marker('check.unmet')}</span>
                  <span>${escapeHtml(pick(check, ['constraint']))}: ${escapeHtml(pick(check, ['evidence']))}</span>
                </div>
              `).join('')}
            </div>
          ` : ''}
        </div>
      `;
      })
      .filter(Boolean);

    if (!rationaleCards.length) return '';

    return `
      <div class="plekify-dossier__section-heading">
        <div class="plekify-dossier__section-heading-row">
          <h2>Property Selection Rationale</h2>
          <span class="plekify-dossier__section-type">Why Each Property</span>
        </div>
        <p>Strategic reasoning behind property selection against guest brief and constraints</p>
      </div>
      <div class="plekify-dossier__rationale-grid">${rationaleCards.join('')}</div>
    `;
  };

  // Render Alternatives Considered
  const renderAlternatives = (data) => {
    const dossierView = getDossierView(data);
    const alternatives = toArray(pick(dossierView, ['alternatives_considered', 'alternativesConsidered']));
    if (!alternatives.length) return '';

    const cards = alternatives.map(alt => {
      const selected = text(pick(alt, ['selected_property', 'selectedProperty']));
      const altList = toArray(pick(alt, ['alternatives']));
      if (!altList.length) return '';

      return `
        <div class="plekify-dossier__alternatives-card">
          <h3 class="plekify-dossier__alternatives-header">Selected: ${escapeHtml(selected)}</h3>
          ${altList.map(a => `
            <div class="plekify-dossier__alternative-item">
              <div>
                <p class="plekify-dossier__alternative-name">${escapeHtml(pick(a, ['property_name', 'propertyName']))}</p>
                <p class="plekify-dossier__alternative-reason">Excluded: ${escapeHtml(pick(a, ['rejection_reason', 'rejectionReason']))}</p>
              </div>
              <span class="plekify-dossier__alternative-score">${Math.round((pick(a, ['qmd_score', 'qmdScore']) || 0) * 100)}%</span>
            </div>
          `).join('')}
        </div>
      `;
    }).filter(Boolean).join('');

    if (!cards) return '';

    return `
      <div class="plekify-dossier__section-heading">
        <div class="plekify-dossier__section-heading-row">
          <h2>Alternatives Considered</h2>
          <span class="plekify-dossier__section-type">Tier B Options</span>
        </div>
        <p>Properties evaluated but excluded, with rejection rationale</p>
      </div>
      <div class="plekify-dossier__alternatives-grid">${cards}</div>
    `;
  };

  // Render Route Feasibility
  const renderRouteFeasibility = (data) => {
    const opIntel = pick(data, ['operator_intelligence', 'operatorIntelligence'], {});
    const routeFeasibility = pick(opIntel, ['route_feasibility', 'routeFeasibility'], {});
    if (!Object.keys(routeFeasibility).length) return '';

    const allValid = pick(routeFeasibility, ['all_valid', 'allValid']);
    const totalDriving = pickNumber(routeFeasibility, ['total_driving_km', 'totalDrivingKm'], 0);
    const totalFlying = pickNumber(routeFeasibility, ['total_flying_hours', 'totalFlyingHours'], 0);
    const warnings = toArray(pick(routeFeasibility, ['warnings']));
    const roadWarnings = toArray(pick(routeFeasibility, ['road_condition_warnings', 'roadConditionWarnings']));

    const warningsHtml = [...warnings, ...roadWarnings.map(w => pick(w, ['warning']))].filter(Boolean).map(w => `
      <div class="plekify-dossier__route-warning">
        <span>${LABELS.marker('flag.warning')}</span>
        <span>${escapeHtml(w)}</span>
      </div>
    `).join('');

    return `
      <div class="plekify-dossier__section-heading">
        <div class="plekify-dossier__section-heading-row">
          <h2>Route Feasibility</h2>
          <span class="plekify-dossier__section-type">Logistics</span>
        </div>
      </div>
      <div class="plekify-dossier__route-summary">
        <div class="plekify-dossier__route-status ${!allValid ? 'plekify-dossier__route-status--warning' : ''}">
          <span>${allValid ? LABELS.marker('check.met') : LABELS.marker('flag.warning')}</span>
          <span>${allValid ? 'All routes validated' : 'Route warnings present'}</span>
        </div>
        <div class="plekify-dossier__route-metrics">
          <div class="plekify-dossier__route-metric">
            <div class="plekify-dossier__route-metric-value">${totalDriving} km</div>
            <div class="plekify-dossier__route-metric-label">Total Driving</div>
          </div>
          <div class="plekify-dossier__route-metric">
            <div class="plekify-dossier__route-metric-value">${totalFlying} hrs</div>
            <div class="plekify-dossier__route-metric-label">Total Flying</div>
          </div>
        </div>
      </div>
      ${warningsHtml ? `<div class="plekify-dossier__route-warnings">${warningsHtml}</div>` : ''}
    `;
  };

  // Render Compliance Verification
  const renderCompliance = (data) => {
    const dossierView = getDossierView(data);
    const compliance = pick(dossierView, ['compliance_summary', 'complianceSummary'], {}) || {};
    if (!Object.keys(compliance).length) return '';

    const visaRules = toArray(pick(compliance, ['visa_rules_applied', 'visaRulesApplied']));
    const carbonTracking = pick(compliance, ['carbon_tracking', 'carbonTracking'], {}) || {};

    let html = '';

    if (visaRules.length) {
      html += `
        <div class="plekify-dossier__compliance-card">
          <p class="plekify-dossier__compliance-title">Visa Rules Applied</p>
          ${visaRules.map((rule) => `
            <div class="plekify-dossier__compliance-item">
              <p class="plekify-dossier__compliance-item-name">
                <span class="plekify-dossier__compliance-badge plekify-dossier__compliance-badge--green">✓ Applied</span>
                ${escapeHtml(text(rule))}
              </p>
            </div>
          `).join('')}
        </div>
      `;
    }

    if (Object.keys(carbonTracking).length) {
      const carbonEnabled = pick(carbonTracking, ['enabled']) ? 'Enabled' : 'Not enabled';
      const estimatedKg = pickNumber(carbonTracking, ['estimated_kg_co2e', 'estimatedKgCo2e'], NaN);
      html += `
        <div class="plekify-dossier__compliance-card">
          <p class="plekify-dossier__compliance-title">Carbon Tracking</p>
          <div class="plekify-dossier__compliance-item">
            <p class="plekify-dossier__compliance-item-name">
              <span class="plekify-dossier__compliance-badge plekify-dossier__compliance-badge--green">${escapeHtml(carbonEnabled)}</span>
              Estimated footprint
            </p>
            <p class="plekify-dossier__compliance-item-detail">${Number.isFinite(estimatedKg) ? `${estimatedKg} kg CO2e` : 'No estimate recorded'}</p>
          </div>
        </div>
      `;
    }

    if (!html) return '';

    return `
      <div class="plekify-dossier__section-heading">
        <div class="plekify-dossier__section-heading-row">
          <h2>Compliance Verification</h2>
          <span class="plekify-dossier__section-type">Regulatory</span>
        </div>
      </div>
      <div class="plekify-dossier__compliance-grid">${html}</div>
    `;
  };

  // Render Commercial Structure
  const renderCommercial = (data) => {
    const dossierView = getDossierView(data);
    const commercial = pick(dossierView, ['commercial_summary', 'commercialSummary'], {}) || {};
    const budgetValidation = pick(dossierView, ['budget_validation', 'budgetValidation'], {}) || {};
    const currency = text(pick(commercial, ['currency'])) || 'ZAR';
    const grandTotal = pick(commercial, ['total_investment', 'totalInvestment']);
    const phaseTotals = toArray(pick(commercial, ['phase_totals', 'phaseTotals']));
    const actualPppn = pickNumber(budgetValidation, ['actual_pppn', 'actualPppn'], NaN);
    const targetMin = pickNumber(budgetValidation, ['target_pppn_min', 'targetPppnMin'], NaN);
    const targetMax = pickNumber(budgetValidation, ['target_pppn_max', 'targetPppnMax'], NaN);
    const targetCurrency = text(pick(budgetValidation, ['target_currency', 'targetCurrency'])) || 'USD';
    const budgetStatus = text(pick(budgetValidation, ['status'])) || '';

    if (!grandTotal && !phaseTotals.length) return '';

    return `
      <div class="plekify-dossier__section-heading">
        <div class="plekify-dossier__section-heading-row">
          <h2>Commercial Structure</h2>
          <span class="plekify-dossier__section-type">Pricing</span>
        </div>
        <p>Full cost breakdown — confidential, not for guest view</p>
      </div>
      <div class="plekify-dossier__commercial-summary">
        <div class="plekify-dossier__commercial-total">
          <span class="plekify-dossier__commercial-total-label">Grand Total</span>
          <span class="plekify-dossier__commercial-total-value">${formatCurrency(grandTotal, currency)}</span>
        </div>
        <div class="plekify-dossier__commercial-lines">
          ${phaseTotals.map(item => `
            <div class="plekify-dossier__commercial-line">
              <span class="plekify-dossier__commercial-line-label">${escapeHtml(text(pick(item, ['label', 'name'])) || 'Phase')}</span>
              <span class="plekify-dossier__commercial-line-value">${formatCurrency(pick(item, ['total', 'phase_total', 'phaseTotal']), currency)}</span>
            </div>
          `).join('')}
        </div>
        ${Number.isFinite(actualPppn) ? `
          <div class="plekify-dossier__commercial-lines">
            <div class="plekify-dossier__commercial-line">
              <span class="plekify-dossier__commercial-line-label">Budget validation</span>
              <span class="plekify-dossier__commercial-line-value">${escapeHtml(`${formatCurrency(actualPppn, targetCurrency)} per person per night`)}</span>
            </div>
            ${Number.isFinite(targetMin) && Number.isFinite(targetMax) ? `
              <div class="plekify-dossier__commercial-line">
                <span class="plekify-dossier__commercial-line-label">Target range</span>
                <span class="plekify-dossier__commercial-line-value">${escapeHtml(`${formatCurrency(targetMin, targetCurrency)} – ${formatCurrency(targetMax, targetCurrency)} per person per night`)}</span>
              </div>
            ` : ''}
            ${budgetStatus ? `
              <div class="plekify-dossier__commercial-line">
                <span class="plekify-dossier__commercial-line-label">Range status</span>
                <span class="plekify-dossier__commercial-line-value">${escapeHtml(LABELS.label(budgetStatus))}</span>
              </div>
            ` : ''}
          </div>
        ` : ''}
      </div>
    `;
  };

  // Render Risk Register (placeholder - can be enhanced with actual risk data)
  const renderRisks = (data) => {
    const dossierView = getDossierView(data);
    const risks = toArray(pick(dossierView, ['risk_register', 'riskRegister']));
    if (!risks.length) return '';

    const riskCards = risks.map((risk) => {
      const severity = text(pick(risk, ['severity']));
      const severityClass = severity === 'high' ? ' plekify-dossier__flag--high' : '';
      return `
      <div class="plekify-dossier__flag${severityClass}">
        <div class="plekify-dossier__flag-content">
          <p class="plekify-dossier__flag-type" style="color:${flagColor(severity)}">${escapeHtml(LABELS.label(severity) || 'risk')}</p>
          <p class="plekify-dossier__flag-text">${escapeHtml(text(pick(risk, ['summary'])) || text(pick(risk, ['code'])))}</p>
          <p class="plekify-dossier__flag-guest">${escapeHtml(LABELS.label(text(pick(risk, ['owner']))) || 'unassigned')}</p>
        </div>
      </div>
    `;
    }).join('');

    return `
      <div class="plekify-dossier__section-heading">
        <div class="plekify-dossier__section-heading-row">
          <h2>Risk Register</h2>
          <span class="plekify-dossier__section-type">Execution Logic</span>
        </div>
        <p>Known operational risks and ownership assignments carried forward into delivery.</p>
      </div>
      <div class="plekify-dossier__flags-grid">${riskCards}</div>
    `;
  };

  // Render Day-by-Day Legs (simplified)
  const renderLegs = (data) => {
    const legs = toArray(pick(data, ['legs', 'Legs', 'segments', 'Segments']));
    if (!legs.length) return '';

    // F2(b): the day narrative repeats the day title as its opening paragraph —
    // drop that duplicated prefix; the title keeps its own "Day Theme" field.
    const dropLeadingTitle = (body, titleText) => {
      const t = text(titleText);
      if (!t || !body || body.slice(0, t.length).toLowerCase() !== t.toLowerCase()) return body;
      return body.slice(t.length).replace(/^[\s·:—–-]+/, '').trim();
    };

    const sorted = [...legs].sort((a, b) =>
      pickNumber(a, ['sequence', 'Sequence'], 0) - pickNumber(b, ['sequence', 'Sequence'], 0)
    );
    let runningDayNumber = 1;

    return sorted.map((segment, idx) => {
      const propertyName =
        text(pick(segment, ['accommodation_name', 'accommodationName'])) ||
        text(pick(segment, ['name', 'title'])) ||
        text(pick(segment, ['destination_name', 'destinationName'])) ||
        `Leg ${idx + 1}`;
      const locationStr = text(pick(segment, ['destination_name', 'destinationName']));
      const startDate = pick(segment, ['start_date', 'startDate']);
      const endDate = pick(segment, ['end_date', 'endDate']);
      const periods = toArray(pick(segment, ['periods', 'Periods']));
      const dayEntries = [];

      periods.forEach((period) => {
        const periodStartDate = parseDate(pick(period, ['start_date', 'startDate']));
        const periodDays = Math.max(1, pickNumber(period, ['days'], 1));
        const titles = toArray(pick(period, ['day_titles', 'dayTitles'])).map(text).filter(Boolean);
        const fallbackTitle = text(pick(period, ['day_title', 'dayTitle'])) || text(pick(period, ['title', 'label']));
        const periodNotes = LABELS.text(stripHtml(pick(period, ['day_narrative', 'dayNarrative', 'notes', 'consultant_notes'])));

        for (let offset = 0; offset < periodDays; offset += 1) {
          const title = titles[offset] || titles[0] || fallbackTitle || `Day ${runningDayNumber}`;
          const dateValue = periodStartDate ? formatDate(addDays(periodStartDate, offset)) : '';
          dayEntries.push({
            dayNumber: runningDayNumber,
            title,
            dateValue,
            notes: dropLeadingTitle(periodNotes, title),
          });
          runningDayNumber += 1;
        }
      });

      const daysHtml = dayEntries.map((entry) => `
        <div class="plekify-dossier__day">
          <div class="plekify-dossier__day-header">
            <span class="plekify-dossier__day-number">Day ${entry.dayNumber}</span>
            ${entry.dateValue ? `<span class="plekify-dossier__day-location">${escapeHtml(entry.dateValue)}</span>` : locationStr ? `<span class="plekify-dossier__day-location">${escapeHtml(locationStr)}</span>` : ''}
          </div>
          <div class="plekify-dossier__day-field">
            <span class="plekify-dossier__field-label">Day Theme</span>
            <span class="plekify-dossier__field-value">${escapeHtml(entry.title)}</span>
          </div>
          ${entry.notes ? `
            <div class="plekify-dossier__day-field">
              <span class="plekify-dossier__field-label">Operational Notes</span>
              <span class="plekify-dossier__field-value">${escapeHtml(entry.notes)}</span>
            </div>
          ` : ''}
        </div>
      `).join('');

      return `
        <div class="plekify-dossier__leg-section">
          <hr class="plekify-dossier__leg-divider" />
          <div class="plekify-dossier__leg-header">
            <h2 class="plekify-dossier__leg-title">Leg ${idx + 1}: ${escapeHtml(propertyName)}</h2>
            <p class="plekify-dossier__leg-subtitle">
              ${escapeHtml(locationStr || propertyName)} ·
              ${formatDateRange(startDate, endDate)}
            </p>
          </div>
          ${daysHtml || '<p class="plekify-dossier__placeholder">No day details available</p>'}
        </div>
      `;
    }).join('');
  };

  // Main render function
  const renderDossier = async (root) => {
    const statusEl = root.querySelector('[data-dossier-status]');
    const identifier = text(root.dataset.itineraryIdentifier);

    if (!identifier) {
      if (statusEl) statusEl.textContent = 'No itinerary identifier configured.';
      return;
    }

    let data = null;
    try {
      data = await fetchCanonicalSource(identifier);
    } catch (e) {
      if (statusEl) {
        if (e.message === 'AUTH') {
          statusEl.innerHTML = 'Authentication required. Please <a href="/account/login?return_url=' + encodeURIComponent(window.location.pathname) + '">log in</a> to view the operator dossier.';
        } else {
          statusEl.textContent = 'Unable to load itinerary data: ' + e.message;
        }
      }
      return;
    }
    if (!data) {
      if (statusEl) statusEl.textContent = 'Unable to load itinerary data.';
      return;
    }
    if (statusEl) statusEl.style.display = 'none';

    // Populate header — eyebrow/title are owned by the masthead (B1); only its meta strip is JS-filled.
    const mastheadMetaEl = root.querySelector('.doc-masthead__meta');
    if (mastheadMetaEl) {
      const meta = buildMastheadMeta(data);
      if (meta) mastheadMetaEl.textContent = meta;
    }

    const routingEl = root.querySelector('[data-dossier-routing]');
    if (routingEl) {
      const routing = buildRoutingLine(data);
      if (routing) routingEl.textContent = routing;
    }

    // Render summary
    const summaryEl = root.querySelector('[data-dossier-summary]');
    if (summaryEl) summaryEl.innerHTML = renderSummary(data);

    // Render all sections
    const sections = [
      ['[data-dossier-journey-dna]', renderJourneyDna],
      ['[data-dossier-flags]', renderFlags],
      ['[data-dossier-confidential]', renderConfidential],
      ['[data-dossier-guests]', renderGuestRegistry],
      ['[data-dossier-property-rationale]', renderPropertyRationale],
      ['[data-dossier-alternatives]', renderAlternatives],
      ['[data-dossier-route-feasibility]', renderRouteFeasibility],
      ['[data-dossier-compliance]', renderCompliance],
      ['[data-dossier-commercial]', renderCommercial],
      ['[data-dossier-risks]', renderRisks],
      ['[data-dossier-legs]', renderLegs],
    ];

    sections.forEach(([selector, renderer]) => {
      const el = root.querySelector(selector);
      if (el) el.innerHTML = renderer(data);
    });

    // Update footer
    const footerMetaEl = root.querySelector('[data-dossier-footer-meta]');
    if (footerMetaEl) {
      const generated = formatDate(new Date().toISOString()) || 'Version date unavailable';
      footerMetaEl.textContent = `Generated: ${generated} | Source: ${identifier}`;
    }
  };

  // Initialize
  const boot = () => {
    document.querySelectorAll(DOSSIER_SELECTOR).forEach(root => renderDossier(root));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (e) => {
    const t = e.target;
    if (t instanceof HTMLElement) {
      if (t.matches(DOSSIER_SELECTOR)) { renderDossier(t); return; }
      t.querySelectorAll(DOSSIER_SELECTOR).forEach(r => renderDossier(r));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plekify-property-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  var hero = document.querySelector('[data-plekify-property-hero]');
  if (!hero) return;

  var video = hero.querySelector('video');
  var poster = hero.querySelector('.plekify-property-hero__poster');
  if (!video) return;

  function revealVideo() {
    video.classList.add('is-ready');
  }

  function attemptPlay() {
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function() {});
    }
  }

  // Reveal video once it has actual frame data
  if (video.readyState >= 2) {
    revealVideo();
    attemptPlay();
  } else {
    video.addEventListener('loadeddata', function onLoaded() {
      revealVideo();
      video.removeEventListener('loadeddata', onLoaded);
    });
    video.addEventListener('canplay', function onCanPlay() {
      revealVideo();
      attemptPlay();
      video.removeEventListener('canplay', onCanPlay);
    });
  }

  // Fallback: reveal video after 4s even if events haven't fired
  setTimeout(function() {
    if (!video.classList.contains('is-ready')) {
      revealVideo();
      attemptPlay();
    }
  }, 4000);

  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) attemptPlay();
  });

  attemptPlay();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plekify-property-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var container = document.querySelector('[data-plekify-property-main]');
  if (!container) return;

  var tabs = container.querySelectorAll('[data-tab]');
  var panels = container.querySelectorAll('[data-tab-panel]');

  function switchTab(tabId, shouldScroll) {
    tabs.forEach(function(t) {
      var active = t.dataset.tab === tabId;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', String(active));
    });
    panels.forEach(function(p) {
      var active = p.dataset.tabPanel === tabId;
      p.classList.toggle('is-active', active);
      p.hidden = !active;
    });
    // Gallery is Overview-only: hide the gallery column + collapse to one column on other tabs.
    container.setAttribute('data-active-tab', tabId);
    container.setAttribute('data-gallery-active', tabId === 'overview' ? 'true' : 'false');
    history.replaceState(null, '', '#' + tabId);
    if (shouldScroll) {
      var activePanel = container.querySelector('[data-tab-panel="' + tabId + '"]');
      if (activePanel) activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var tabId = tab.dataset.tab;
      var hero = document.querySelector('.plekify-property-hero');
      var heroVisible = hero && hero.getBoundingClientRect().bottom > 0;
      switchTab(tabId, heroVisible);
    });
  });

  // Hash-based deep linking
  var hash = window.location.hash.replace('#', '');
  if (hash) {
    var target = container.querySelector('[data-tab="' + hash + '"]');
    if (target) {
      switchTab(hash, false);
      // Defer scroll so layout is settled
      requestAnimationFrame(function() {
        var activePanel = container.querySelector('[data-tab-panel="' + hash + '"]');
        if (activePanel) activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  // ===== HORIZON-STYLE GALLERY DIALOG =====
  window.PlekifyGallery = (function() {
    var dialog = container.querySelector('[data-gallery-dialog]');
    var stage = container.querySelector('[data-gallery-dialog-stage]');
    var thumbs = container.querySelector('[data-gallery-dialog-thumbs]');
    var figures = stage ? Array.from(stage.querySelectorAll('[data-gallery-dialog-figure]')) : [];
    var thumbButtons = thumbs ? Array.from(thumbs.querySelectorAll('[data-gallery-dialog-thumb]')) : [];
    var currentIndex = 0;
    var scrollTimeout = null;

    function open(index) {
      if (!dialog || !stage) return;
      currentIndex = index || 0;
      dialog.showModal();
      document.body.style.overflow = 'hidden';

      // Scroll to target image without animation first
      var target = figures[currentIndex];
      if (target) {
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
      }

      updateThumbs(currentIndex);

      // Set up scroll sync after a brief delay
      requestAnimationFrame(function() {
        stage.addEventListener('scroll', onStageScroll, { passive: true });
      });
    }

    function close() {
      if (!dialog) return;
      stage.removeEventListener('scroll', onStageScroll);
      dialog.close();
      document.body.style.overflow = '';
    }

    function scrollTo(index) {
      if (!figures[index]) return;
      currentIndex = index;
      figures[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
      updateThumbs(index);
    }

    function onStageScroll() {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        if (!stage) return;
        var stageTop = stage.scrollTop;
        var stageHeight = stage.clientHeight;
        var bestIndex = 0;
        var bestOffset = Infinity;

        figures.forEach(function(fig, i) {
          var offset = Math.abs(fig.offsetTop - stageTop);
          if (offset < bestOffset) {
            bestOffset = offset;
            bestIndex = i;
          }
        });

        if (bestIndex !== currentIndex) {
          currentIndex = bestIndex;
          updateThumbs(bestIndex);
        }
      }, 100);
    }

    function updateThumbs(activeIndex) {
      thumbButtons.forEach(function(btn, i) {
        btn.classList.toggle('is-active', i === activeIndex);
        if (i === activeIndex && thumbs) {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    // Close on backdrop click
    if (dialog) {
      dialog.addEventListener('click', function(e) {
        if (e.target === dialog || e.target.hasAttribute('data-gallery-dialog-backdrop')) {
          close();
        }
      });

      // Close button
      var closeBtn = dialog.querySelector('[data-gallery-dialog-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          close();
        });
      }

      // Click on figure closes dialog (Horizon behavior)
      figures.forEach(function(fig) {
        fig.addEventListener('click', function(e) {
          // Only close if clicking the figure itself or the image
          if (e.target === fig || e.target.tagName === 'IMG') {
            close();
          }
        });
      });
    }

    // Keyboard nav
    document.addEventListener('keydown', function(e) {
      if (!dialog || !dialog.open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight' || e.key === 'PageDown' || e.key === ' ') {
        e.preventDefault();
        if (currentIndex < figures.length - 1) scrollTo(currentIndex + 1);
      }
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft' || e.key === 'PageUp') {
        e.preventDefault();
        if (currentIndex > 0) scrollTo(currentIndex - 1);
      }
    });

    return { open: open, close: close, scrollTo: scrollTo };
  })();

  // ===== YOUTUBE CLICK-TO-PLAY FACADE =====
  container.querySelectorAll('[data-video-facade]').forEach(function(facade) {
    facade.addEventListener('click', function() {
      var ytId = facade.dataset.ytId;
      var ytTitle = facade.dataset.ytTitle || 'Video';
      if (!ytId) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0';
      iframe.title = ytTitle;
      iframe.allowFullscreen = true;
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = 'none';
      iframe.style.display = 'block';
      facade.innerHTML = '';
      facade.appendChild(iframe);
      facade.style.cursor = 'default';
    });
  });
})();

/* ──────────────────────────────────────────────────────────
   Mobile gallery carousel — pagination dots
   Activates the dot matching the most-visible image in the
   horizontally-scrolling gallery (mobile only).
   ────────────────────────────────────────────────────────── */
(function() {
  if (typeof window === 'undefined') return;

  function initGalleryDots() {
    var gallery = document.querySelector('[data-property-gallery]');
    var dotsWrap = document.querySelector('[data-property-gallery-dots]');
    if (!gallery || !dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('.property-gallery-dots__dot');
    var items = gallery.querySelectorAll('.property-gallery__item');
    if (!dots.length || !items.length) return;

    function setActive(index) {
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    function update() {
      // Only run on mobile (gallery has horizontal scroll)
      if (window.innerWidth > 750) return;
      var galleryRect = gallery.getBoundingClientRect();
      var center = galleryRect.left + galleryRect.width / 2;
      var bestIdx = 0;
      var bestDist = Infinity;
      items.forEach(function(item, i) {
        var r = item.getBoundingClientRect();
        var itemCenter = r.left + r.width / 2;
        var dist = Math.abs(itemCenter - center);
        if (dist < bestDist) { bestDist = dist; bestIdx = i; }
      });
      setActive(bestIdx);
    }

    var ticking = false;
    gallery.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        update();
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryDots, { once: true });
  } else {
    initGalleryDots();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plekify-v10-ars-chart"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  // Animate bars on scroll into view; render final state under reduced-motion.
  function init(root) {
    var bars = root.querySelectorAll('.plk-ars__bar');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setFinal() { bars.forEach(function (b) { b.style.width = b.style.getPropertyValue('--bar-h'); }); }
    function reset() { bars.forEach(function (b) { b.style.width = '0%'; }); }
    if (reduce) { setFinal(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reset(); requestAnimationFrame(function () { requestAnimationFrame(setFinal); }); }
      });
    }, { threshold: 0.2 });
    io.observe(root.querySelector('.plk-ars__chart'));
  }
  document.querySelectorAll('.plekify-v10-ars').forEach(init);
})();

/* Mobile tier-card "What this means" toggle (brief §4) — slides the meaning body open. */
(function () {
  'use strict';
  function initMeaning() {
    document.querySelectorAll('[data-plk-ars-meaning]').forEach(function (btn) {
      if (btn.__plkArsBound) return;
      btn.__plkArsBound = true;
      btn.addEventListener('click', function () {
        var row = btn.closest('.plk-ars__tier-row');
        if (!row) return;
        var open = row.classList.toggle('is-meaning-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMeaning);
  } else {
    initMeaning();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plekify-v10-race"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * PLEKIFY V10 — Enhanced Booking Race (FIXED 2026-07-03)
   *
   * SINGLE SOURCE: the total booking time is derived from the friction score,
   * calibrated so Plekify's real measured 19s anchors the scale (CALIBRATION
   * = 19/10.9). If a racer carries a numeric real duration (Plekify), it
   * overrides and is used directly. Both the bar pace and the stopwatch read
   * from this ONE value — they can no longer contradict each other.
   *
   * PERSIST: the finishing time does NOT disappear. After all bars finish,
   * the final state (times + ✓ done) is held for HOLD_MS before replay.
   * prefers-reduced-motion → final state permanently, no loop.
   */

  var HOLD_MS = 6000; // hold final state (times visible) before replaying

  function getRacerData(row) {
    var friction = parseFloat(row.getAttribute('data-friction')) || 0;
    var durationMs = parseInt(row.getAttribute('data-duration'), 10) || 2000;
    var durationS = parseFloat(row.getAttribute('data-duration-s')) || 2.0;
    var totalSeconds = parseFloat(row.getAttribute('data-total-seconds')) || durationS;
    var hasReal = row.getAttribute('data-has-real') === 'true';
    return {
      friction: friction,
      durationMs: durationMs,
      durationS: durationS,
      totalSeconds: totalSeconds,
      hasReal: hasReal,
      bar: row.querySelector('[data-plk-bar]'),
      timer: row.querySelector('[data-plk-timer]'),
      done: row.querySelector('[data-plk-done]')
    };
  }

  function formatTime(s) {
    return Math.round(s) + 's';
  }

  /** Render the FINAL static state — bars at 100%, stopwatch at total time, ✓ done. */
  function setFinalState(row) {
    var d = getRacerData(row);
    if (!d.bar) return;
    d.bar.style.width = '100%';
    if (d.timer) d.timer.textContent = formatTime(d.totalSeconds);
    if (d.done) d.done.setAttribute('data-plk-done-shown', '');
  }

  function runRace(raceEl, racers, state) {
    // Reset bars + timers, then replay. The final time will be held after finish.
    racers.forEach(function (r) {
      r.bar.style.width = '0%';
      if (r.timer) r.timer.textContent = '0s';
      if (r.done) r.done.removeAttribute('data-plk-done-shown');
      r.finished = false;
    });
    raceEl.classList.remove('is-racing');
    void raceEl.offsetWidth;
    raceEl.classList.add('is-racing');

    var startTime = null;

    function frame(ts) {
      if (!state.racing) return;
      if (startTime === null) startTime = ts;
      var elapsed = ts - startTime;

      var allDone = true;
      racers.forEach(function (r) {
        var t = Math.min(elapsed / r.durationMs, 1);

        // Stopwatch ticks 0 → totalSeconds in sync with the bar.
        if (r.timer) {
          if (t >= 1) {
            r.timer.textContent = formatTime(r.totalSeconds);
          } else {
            r.timer.textContent = formatTime(t * r.totalSeconds);
          }
        }

        if (t >= 1 && !r.finished) {
          r.finished = true;
          r.bar.style.width = '100%';
          if (r.done) r.done.setAttribute('data-plk-done-shown', '');
        }

        if (t < 1) allDone = false;
      });

      if (!allDone) {
        state.rafId = requestAnimationFrame(frame);
      } else {
        // HOLD the final state (times visible) before replaying.
        state.loopId = setTimeout(function () {
          if (state.racing) runRace(raceEl, racers, state);
        }, HOLD_MS);
      }
    }

    state.rafId = requestAnimationFrame(frame);
  }

  function initRace(root) {
    var raceEl = root.querySelector('[data-plk-race]');
    if (!raceEl) return;
    var rows = root.querySelectorAll('[data-plk-racer]');
    if (!rows.length) return;

    var racers = [];
    rows.forEach(function (row) {
      var d = getRacerData(row);
      d.finished = false;
      racers.push(d);
    });

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      rows.forEach(setFinalState);
      return;
    }

    var state = { rafId: null, loopId: null, racing: false };

    function start() {
      if (state.racing) return;
      state.racing = true;
      runRace(raceEl, racers, state);
    }

    function stop() {
      state.racing = false;
      if (state.rafId) { cancelAnimationFrame(state.rafId); state.rafId = null; }
      if (state.loopId) { clearTimeout(state.loopId); state.loopId = null; }
      raceEl.classList.remove('is-racing');
      racers.forEach(function (r) {
        r.bar.style.width = '0%';
        r.finished = false;
        if (r.timer) r.timer.textContent = '0s';
        if (r.done) r.done.removeAttribute('data-plk-done-shown');
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) start(); else stop();
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });

    observer.observe(raceEl);
  }

  function initRaces() {
    document.querySelectorAll('[data-plk-race-root]').forEach(initRace);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRaces);
  } else {
    initRaces();
  }
})();

/* Mobile leaderboard Details toggle (brief §3) — reveals the metrics row. */
(function () {
  'use strict';
  function initDetails() {
    document.querySelectorAll('[data-plk-race-root]').forEach(function (root) {
      root.querySelectorAll('[data-plk-race-details]').forEach(function (btn) {
        if (btn.__plkDetailsBound) return;
        btn.__plkDetailsBound = true;
        btn.addEventListener('click', function () {
          var row = btn.closest('.plk-race__row');
          if (!row) return;
          var open = row.classList.toggle('is-details-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDetails);
  } else {
    initDetails();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plekify-v10-talk-to-us"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Cache-bust marker (bumped 2026-07-29 for Turnstile gate): a no-op global
  // whose presence changes compiled_assets/scripts.js content so Shopify assigns
  // a NEW bundle version on the next theme PUBLISH → new URL → bypasses
  // Cloudflare's 1y-pinned old bundle. Keep this line — do NOT remove in a
  // `theme push --live` or the bundle version reverts and the CDN serves the
  // stale old bundle again. (Shopify's bundler may strip the assignment itself,
  // but it still shifts the compiled output enough to force a new version on
  // publish.) No functional effect. The Turnstile JS gate below
  // ships only after a PUBLISH turns the bundle over (same footgun as the
  // fire-on-submit); until then the widget HTML ships but the gate is inert.
  window.__plk_gads_cb = '2026-08-03-softmode';
  var form = document.querySelector('[data-plk-talk-form]');
  if (!form) return;

  var submit = form.querySelector('[data-plk-talk-submit]');
  var successEl = form.querySelector('[data-plk-talk-success]');
  var errorEl = form.querySelector('[data-plk-talk-error]');
  var honeypot = form.querySelector('input[name="plk_hp_website"]');

  // Honour reduced motion: do not move focus aggressively. We only reveal
  // the status region; no scroll/transform animations are triggered.
  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setStatus(state, message) {
    if (state === 'success') {
      if (successEl) {
        if (message) successEl.textContent = message;
        successEl.hidden = false;
      }
      if (errorEl) errorEl.hidden = true;
      // Hide the field set so the form reads as "done" but the DOM keeps values.
      Array.prototype.forEach.call(form.querySelectorAll('.plk-talk__field'), function (f) {
        f.setAttribute('hidden', '');
      });
      if (submit) submit.setAttribute('hidden', '');
    } else if (state === 'error') {
      if (errorEl) {
        if (message) errorEl.textContent = message;
        errorEl.hidden = false;
      }
      if (successEl) successEl.hidden = true;
    }
  }

  form.addEventListener('submit', function (e) {
    // Honeypot: if the hidden field has a value, silently pretend success and drop it.
    if (honeypot && honeypot.value !== '') {
      e.preventDefault();
      setStatus('success');
      return;
    }

    // ─── Cloudflare Turnstile gate (Phase 3 — SOFT MODE). Active only when the
    // widget is present (site key set in the travel_2022 overlay). A solved token
    // is appended to the payload below and the server siteverifies it. A MISSING
    // token is no longer blocked: ad-blockers that block challenges.cloudflare.com
    // leave real humans with no widget at all, and hard-bouncing them was the
    // leading cause of zero leads — so a no-token submit PROCEEDS (honeypot →
    // conversion fire → POST), and the server's TURNSTILE_ENFORCE=false path
    // (validate-if-present / soft-accept-absent) absorbs it. The honeypot, per-IP
    // rate limit and disposable-email block remain the bot net. ───
    var tsWidget = form.querySelector('.cf-turnstile');
    if (tsWidget) {
      var tsErrorEl = form.querySelector('[data-plk-turnstile-error]');
      if (tsErrorEl) tsErrorEl.hidden = true;   // soft mode never bounces on a missing token
    }

    e.preventDefault();

    // Google Ads conversion — fire on genuine submit INTENT here, NOT in the
    // fetch .then() below. Reason: app.plekify.com is served directly from the
    // origin (no CDN edge), so from some browsers/regions the POST response
    // never returns (timeout/CORS), which means a .then()-based fire would
    // silently never run and the conversion would never be counted. The POST
    // itself still reaches the server and creates the waitlist entry, so the
    // lead is captured regardless. Firing here — after the honeypot filter,
    // gated on a non-empty email, and once per page load (form.__plk_gads_fired)
    // — counts the conversion the moment a real user submits; transaction_id
    // dedupes the rare double-submit that slips past the guard. Guarded so a
    // missing/blocked gtag never breaks the form UX.
    try {
      if (!form.__plk_gads_fired) {
        var _em = form.querySelector('#plk-talk-email');
        if (_em && _em.value.trim() && typeof window.gtag === 'function') {
          form.__plk_gads_fired = true;
          gtag('event', 'conversion', {
            send_to: 'AW-18356378284/TQFwCOuYitgcEKy1gLFE',
            value: 1.0,
            currency: 'ZAR',
            transaction_id: 'plk-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8)
          });
        }
      }
    } catch (err) { /* conversion tracking must never break the form */ }

    // ─── Build the JSON payload, mapping visible fields to the API contract ───
    // API requires: full_name, email, property_name, country (proposal branch).
    // website_url is no longer required (Phase 1 dropped it; the honeypot was
    // renamed to plk_hp_website so website_url is no longer overloaded). We do
    // NOT send website_url here — real users send neither website_url nor the
    // honeypot. The Turnstile token is appended below (cf-turnstile-response).
    var nameEl = form.querySelector('#plk-talk-name');
    var emailEl = form.querySelector('#plk-talk-email');
    var companyEl = form.querySelector('#plk-talk-company');
    var roleEl = form.querySelector('#plk-talk-role');
    var pmsEl = form.querySelector('#plk-talk-pms');
    var wantEl = form.querySelector('#plk-talk-want');
    var attributionEl = form.querySelector('#plk-talk-attribution');

    var whatYouWant = (wantEl && wantEl.value || '').trim();
    var role = (roleEl && roleEl.value || '').trim();
    var attribution = (attributionEl && attributionEl.value || '').trim();

    // Compose a human-readable message from the free-text + auxiliary fields.
    var messageParts = [];
    if (whatYouWant) messageParts.push(whatYouWant);
    if (role) messageParts.push('Role: ' + role);
    if (attribution) messageParts.push('How they heard: ' + attribution);
    var message = messageParts.join('\n\n');

    var payload = {
      full_name: (nameEl && nameEl.value || '').trim(),
      email: (emailEl && emailEl.value || '').trim(),
      property_name: (companyEl && companyEl.value || '').trim(),
      current_pms: (pmsEl && pmsEl.value || '').trim(),
      country: 'Unspecified',               // required by API; not surfaced visibly
      message: message,
      source: 'plekify-homepage-pilot'
    };
    // Turnstile token (Phase 2) — append the solved token so the API siteverifies
    // it server-side. cf-turnstile-response is the canonical field name.
    var _tsToken = form.querySelector('[name="cf-turnstile-response"]');
    if (_tsToken && _tsToken.value) {
      payload['cf-turnstile-response'] = _tsToken.value;
    }

    if (submit) {
      submit.disabled = true;
      submit.setAttribute('data-plk-talk-submitting', 'true');
    }

    var endpoint = form.getAttribute('action');
    // If the action is '#' (post_url not set), we cannot POST — surface an inline error
    // rather than letting the native form reload the page.
    if (!endpoint || endpoint === '#' || endpoint === '') {
      setStatus('error', 'This form is not connected yet. Please email the founder directly.');
      if (submit) { submit.disabled = false; submit.removeAttribute('data-plk-talk-submitting'); }
      return;
    }

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        // Treat any 2xx as success; 3xx redirects are followed by fetch automatically.
        if (res.ok) return res.text().then(function (t) {
          // Some APIs return empty 204; that's fine.
          try { return t ? JSON.parse(t) : {}; }
          catch (_) { return {}; }
        });
        // Non-2xx: try to surface server message, else generic. The waitlist API
        // returns { success:false, error:"..." } on validation failures.
        return res.text().then(function (t) {
          var msg = 'Could not send — please try again, or email the founder.';
          try {
            var j = JSON.parse(t);
            if (j) {
              if (j.error) msg = j.error;
              else if (j.message) msg = j.message;
            }
          } catch (_) {}
          var err = new Error(msg);
          err.status = res.status;
          throw err;
        });
      })
      .then(function () {
        // Conversion is fired on the submit event (above), not here. Firing in
        // the success callback was unreliable because the app.plekify.com
        // response can fail to return to some browsers (origin-direct, no CDN).
        // See the note above the payload build.
        setStatus('success');
      })
      .catch(function (err) {
        setStatus('error', err && err.message ? err.message : 'Network error — please try again.');
        if (submit) { submit.disabled = false; submit.removeAttribute('data-plk-talk-submitting'); }
        // Turnstile tokens are single-use: reset the widget so a retry gets a
        // fresh token instead of resubmitting the redeemed one (timeout-or-duplicate).
        if (form.querySelector('.cf-turnstile') && window.turnstile) {
          try { window.turnstile.reset(); } catch (_) {}
        }
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plekify-v8-booking-comparison"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /**
   * Booking Race Animation v3.2
   * Bars animate at 1/10th actual booking time with LINEAR timing.
   * Live stopwatch timer counts up in sync with bar progress.
   */

  const TIME_SCALE = 10;

  function initBookingRace() {
    const raceContainers = document.querySelectorAll('[data-booking-race]');

    raceContainers.forEach(container => {
      const raceEl = container.querySelector('.plk-race');
      if (!raceEl) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        raceEl.classList.add('is-racing');
        setFinalTimerStates(raceEl);
        return;
      }

      let raceTimeout;
      let timerRafId;
      let isRacing = false;

      const bars = raceEl.querySelectorAll('.plk-race__bar');
      let maxDuration = 0;
      bars.forEach(bar => {
        const duration = parseFloat(getComputedStyle(bar).getPropertyValue('--race-duration')) || 3;
        maxDuration = Math.max(maxDuration, duration);
      });

      const PAUSE_DURATION = 2000;
      const RACE_DURATION = maxDuration * 1000;

      function setFinalTimerStates(el) {
        const rows = el.querySelectorAll('.plk-race__row');
        rows.forEach(row => {
          const timer = row.querySelector('.plk-race__timer');
          const timeAttr = row.getAttribute('data-time');
          if (timer && timeAttr) {
            timer.textContent = '~' + timeAttr + 's';
          }
        });
      }

      function resetTimers(el) {
        const timers = el.querySelectorAll('.plk-race__timer');
        timers.forEach(timer => { timer.textContent = '0s'; });
      }

      function updateTimers(el, elapsedMs) {
        const rows = el.querySelectorAll('.plk-race__row');
        rows.forEach(row => {
          const timer = row.querySelector('.plk-race__timer');
          const bar = row.querySelector('.plk-race__bar');
          if (!timer || !bar) return;

          const timeAttr = parseFloat(row.getAttribute('data-time')) || 0;
          const durationMs = parseFloat(getComputedStyle(bar).getPropertyValue('--race-duration')) * 1000;

          // Linear progress matching CSS linear animation
          const progress = Math.min(elapsedMs / durationMs, 1);
          const displayedTime = Math.round(progress * timeAttr);

          if (progress >= 1) {
            timer.textContent = '~' + timeAttr + 's';
          } else {
            timer.textContent = displayedTime + 's';
          }
        });
      }

      function animateTimers(el, startTime) {
        const now = performance.now();
        const elapsed = now - startTime;

        updateTimers(el, elapsed);

        if (elapsed < RACE_DURATION + 300) {
          timerRafId = requestAnimationFrame(() => animateTimers(el, startTime));
        }
      }

      function startRace() {
        if (isRacing) return;
        isRacing = true;

        raceEl.classList.remove('is-racing');
        resetTimers(raceEl);
        void raceEl.offsetWidth;
        raceEl.classList.add('is-racing');

        const startTime = performance.now();
        timerRafId = requestAnimationFrame(() => animateTimers(raceEl, startTime));

        raceTimeout = setTimeout(() => {
          isRacing = false;
          startRace();
        }, RACE_DURATION + PAUSE_DURATION);
      }

      function stopRace() {
        clearTimeout(raceTimeout);
        if (timerRafId) cancelAnimationFrame(timerRafId);
        raceEl.classList.remove('is-racing');
        isRacing = false;
        resetTimers(raceEl);
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            startRace();
          } else {
            stopRace();
          }
        });
      }, {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
      });

      observer.observe(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBookingRace);
  } else {
    initBookingRace();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plekify-v8-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tabs = document.querySelectorAll('.v8-showcase-tab');
  var panels = document.querySelectorAll('.v8-showcase-panel');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-tab');

      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('is-active');
        p.hidden = true;
      });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      var activePanel = document.querySelector('.v8-showcase-panel[data-panel="' + target + '"]');
      if (activePanel) {
        activePanel.classList.add('is-active');
        activePanel.hidden = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wetu-all-accommodations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const carousel = document.querySelector('[data-carousel="accommodations"]');
    if (!carousel) return;

    const cards = carousel.querySelectorAll('.wetu-accommodation-card');
    const prevBtn = document.querySelector('[data-carousel-prev]');
    const nextBtn = document.querySelector('[data-carousel-next]');
    const dotsContainer = document.querySelector('[data-carousel-dots]');
    
    if (!cards.length) return;

    let currentIndex = 0;
    const totalCards = cards.length;

    // Create dots
    if (dotsContainer) {
      for (let i = 0; i < totalCards; i++) {
        const dot = document.createElement('button');
        dot.className = `carousel-nav__dot${i === 0 ? ' is-active' : ''}`;
        dot.setAttribute('aria-label', `Go to property ${i + 1}`);
        dot.addEventListener('click', () => goToSlide(i));
        dotsContainer.appendChild(dot);
      }
    }

    function updateUI() {
      // Update dots
      if (dotsContainer) {
        dotsContainer.querySelectorAll('.carousel-nav__dot').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === currentIndex);
        });
      }

      // Update buttons
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === totalCards - 1;
    }

    function goToSlide(index) {
      if (index < 0 || index >= totalCards) return;
      currentIndex = index;
      cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      updateUI();
    }

    // Detect scroll to update current index
    let scrollTimeout;
    carousel.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const cardWidth = cards[0].offsetWidth + 24; // gap
        const newIndex = Math.round(carousel.scrollLeft / cardWidth);
        if (newIndex !== currentIndex) {
          currentIndex = Math.max(0, Math.min(newIndex, totalCards - 1));
          updateUI();
        }
      }, 50);
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1));

    updateUI();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wetu-all-transfers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Handle "View on Map" clicks
    document.querySelectorAll('[data-map-route]').forEach(btn => {
      btn.addEventListener('click', () => {
        const routeIndex = btn.dataset.mapRoute;
        // Scroll to map section and highlight route
        const mapSection = document.getElementById('itinerary-map-section');
        if (mapSection) {
          mapSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Dispatch event to highlight route
          document.dispatchEvent(new CustomEvent('wetu:highlight-route', {
            detail: { routeIndex: parseInt(routeIndex) }
          }));
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wetu-itinerary-chronological-days"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.itin-chrono');
    if (!root) return;

    let pinMap = {};
    let linkManifest = {};
    try {
      pinMap = JSON.parse(root.dataset.pinMap || '{}');
    } catch (e) {
      pinMap = {};
    }
    try {
      linkManifest = JSON.parse(root.dataset.linkManifest || '{}');
    } catch (e) {
      linkManifest = {};
    }

    const pinRegex = new RegExp('{' + '{PIN:(\\d+)\\|([^}]+)}' + '}', 'g');
    const escapeHtml = (value) => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    const replacePinTokens = (content) => String(content || '').replace(pinRegex, (match, id, text) => {
      const status = linkManifest[id];
      if (status && status !== 'found') {
        return escapeHtml(text);
      }
      const handle = pinMap[id];
      if (!handle) {
        return escapeHtml(text);
      }
      return `<a href="/products/${handle}">${escapeHtml(text)}</a>`;
    });

    const applyPinLinks = (scope = document) => {
      const elements = scope.querySelectorAll('[data-pin-links]');
      elements.forEach((el) => {
        if (!el.innerHTML.includes('{' + '{PIN:')) return;
        el.innerHTML = replacePinTokens(el.innerHTML);
      });
    };

    const humanizeRouteMode = (modeRaw, labelRaw) => {
      const mode = String(modeRaw || 'Transfer');
      const label = String(labelRaw || '');
      switch (mode) {
        case 'ScheduledFlight':
          return 'Scheduled flight';
        case 'CharterFlight':
          return 'Charter flight';
        case 'Transfer':
          return label === 'Private' ? 'Private transfer' : 'Transfer';
        case 'Rail':
        case 'Train':
          return 'Rail transfer';
        case 'Selfdrive':
          return 'Self-drive';
        case 'Boat':
          return 'Boat transfer';
        default:
          return mode;
      }
    };

    const humanizeHandle = (handle) => String(handle || '')
      .split('-')
      .filter(Boolean)
      .map((word) => {
        const upperTokenList = new Set(['cpt', 'dur', 'jnb', 'or']);
        if (upperTokenList.has(word.toLowerCase())) return word.toUpperCase();
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');

    const normalizeRouteLocationLabels = (scope = document) => {
      const anchors = scope.querySelectorAll('.itin-chrono__timeline-route a');
      anchors.forEach((anchor) => {
        const currentText = anchor.textContent.replace(/\s+/g, ' ').trim();
        if (!/^Location PIN \d+$/i.test(currentText)) return;

        const href = anchor.getAttribute('href') || '';
        const match = href.match(/\/products\/([^/?#]+)/i);
        if (!match) return;

        const pretty = humanizeHandle(match[1]);
        if (pretty) {
          anchor.textContent = pretty;
        }
      });
    };

    const formatSnoopNarrative = (scope = document) => {
      const blocks = scope.querySelectorAll('.itin-chrono__narrative');
      blocks.forEach((block) => {
        if (block.dataset.snoopEnhanced === 'true') return;

        const paragraphs = [...block.querySelectorAll(':scope > p')];
        paragraphs.forEach((paragraph) => {
          const heading = paragraph.querySelector(':scope > strong');
          if (!heading) return;

          const headingText = heading.textContent.replace(/\s+/g, ' ').trim();
          if (!headingText) return;

          if (/^Day\s+\d+\s*--/i.test(headingText)) {
            paragraph.classList.add('itin-chrono__snoop-title');
            return;
          }

          if (/^Pulse\b/i.test(headingText)) {
            paragraph.classList.add('itin-chrono__snoop-card', 'itin-chrono__snoop-card--pulse');
            heading.textContent = 'Pulse';
            return;
          }

          if (/^Street Intel\b/i.test(headingText)) {
            paragraph.classList.add('itin-chrono__snoop-card', 'itin-chrono__snoop-card--intel');
            heading.textContent = 'Street Intel';
            return;
          }

          if (/^Closeout\b/i.test(headingText)) {
            paragraph.classList.add('itin-chrono__snoop-card', 'itin-chrono__snoop-card--closeout');
            heading.textContent = 'Closeout';
            return;
          }

          if (/^Run Sheet\b/i.test(headingText)) {
            const maybeList = paragraph.nextElementSibling;
            if (maybeList && maybeList.tagName === 'UL') {
              const details = document.createElement('details');
              details.className = 'itin-chrono__snoop-runsheet';

              const summary = document.createElement('summary');
              summary.textContent = 'Run Sheet';
              details.appendChild(summary);
              details.appendChild(maybeList);

              paragraph.replaceWith(details);
            }
          }
        });

        block.dataset.snoopEnhanced = 'true';
      });
    };

    const injectNarrativeCues = (scope = document) => {
      const dayCards = scope.querySelectorAll('.itin-chrono__day');
      dayCards.forEach((dayCard) => {
        if (dayCard.dataset.snoopCuesInjected === 'true') return;
        if (dayCard.querySelector('.itin-chrono__commentary-stream')) {
          dayCard.dataset.snoopCuesInjected = 'true';
          return;
        }

        const runsheetItems = Array.from(dayCard.querySelectorAll('.itin-chrono__narrative .itin-chrono__snoop-runsheet ul li'));
        if (runsheetItems.length === 0) return;

        const cueRows = runsheetItems.map((item) => {
          const clone = item.cloneNode(true);
          const firstStrong = clone.querySelector('strong');
          let time = '';
          if (firstStrong) {
            const timeMatch = (firstStrong.textContent || '').match(/\d{1,2}:\d{2}/);
            if (timeMatch) {
              time = timeMatch[0];
            }
            firstStrong.remove();
          }

          const bodyHtml = clone.innerHTML.replace(/^\s*[—-]\s*/, '').trim();
          if (!bodyHtml) return null;
          return {
            time,
            minutes: toMinutes(time),
            bodyHtml,
          };
        }).filter(Boolean).sort((a, b) => a.minutes - b.minutes);

        if (cueRows.length === 0) return;

        const commentarySection = document.createElement('section');
        commentarySection.className = 'itin-chrono__commentary-stream';
        commentarySection.setAttribute('data-pin-links', '');
        commentarySection.innerHTML = `
          <h3 class="itin-chrono__section-title">Snoop live wire</h3>
          <ul class="itin-chrono__commentary-list" role="list">
            ${cueRows.map((row) => `
              <li class="itin-chrono__commentary-item">
                ${row.time ? `<span class="itin-chrono__commentary-time">${escapeHtml(row.time)}</span>` : '<span class="itin-chrono__commentary-time"></span>'}
                <div class="itin-chrono__commentary-body">${row.bodyHtml}</div>
              </li>
            `).join('')}
          </ul>
        `;

        const timelineSection = dayCard.querySelector('.itin-chrono__timeline');
        if (timelineSection && timelineSection.parentNode) {
          timelineSection.insertAdjacentElement('afterend', commentarySection);
        } else {
          const narrativeSection = dayCard.querySelector('.itin-chrono__narrative');
          if (narrativeSection && narrativeSection.parentNode) {
            narrativeSection.insertAdjacentElement('beforebegin', commentarySection);
          }
        }

        dayCard.dataset.snoopCuesInjected = 'true';
      });
    };

    const suppressRunSheetWhenLiveWirePresent = (scope = document) => {
      const dayCards = scope.querySelectorAll('.itin-chrono__day');
      dayCards.forEach((dayCard) => {
        if (!dayCard.querySelector('.itin-chrono__commentary-stream')) return;
        dayCard.querySelectorAll('.itin-chrono__narrative .itin-chrono__snoop-runsheet').forEach((runsheet) => {
          runsheet.remove();
        });
      });
    };

    const decodeEntities = (() => {
      const textarea = document.createElement('textarea');
      return (value) => {
        textarea.innerHTML = String(value || '');
        return textarea.value;
      };
    })();

    const containsHtml = (value) => /<\/?[a-z][\s\S]*>/i.test(String(value || ''));

    const fieldValue = (obj, key) => {
      if (!obj || typeof obj !== 'object') return null;
      const value = obj[key];
      if (value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value')) {
        return value.value;
      }
      return value ?? null;
    };

    const extractRichText = (input) => {
      if (!input) return '';
      if (typeof input === 'object') {
        if (Array.isArray(input.children)) {
          return input.children.map((child) => extractRichText(child)).join(' ');
        }
        if (typeof input.value === 'string') {
          return input.value;
        }
        return '';
      }

      const raw = String(input).trim();
      if (!raw) return '';
      if (raw.startsWith('{') || raw.startsWith('[')) {
        try {
          const parsed = JSON.parse(raw);
          return extractRichText(parsed);
        } catch (error) {
          return raw;
        }
      }
      return raw;
    };

    const prettyText = (value) => {
      const text = extractRichText(value).trim();
      if (!text) return '';
      const decoded = decodeEntities(text).trim();
      if (!decoded) return '';

      if (containsHtml(decoded)) {
        return replacePinTokens(decoded);
      }

      const paragraphHtml = escapeHtml(decoded)
        .replace(/\n\n+/g, '</p><p>')
        .replace(/\n/g, '<br>');
      return `<p>${replacePinTokens(paragraphHtml)}</p>`;
    };

    const normalizeList = (raw) => {
      if (Array.isArray(raw)) return raw;
      if (typeof raw === 'string') {
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }
      return [];
    };

    const normalizeActivities = (period) => normalizeList(fieldValue(period, 'activities') || []);
    const normalizeCommentaryItems = (period) => normalizeList(fieldValue(period, 'commentary_items') || []);
    const normalizeInsertBlocks = (period) => normalizeList(fieldValue(period, 'insert_blocks') || []);
    const previewDesktopMediaQuery = window.matchMedia('(min-width: 900px)');
    const previewQueryParam = 'chronoPreview';
    const previewEligiblePathPrefixes = ['/products/', '/pages/', '/collections/'];

    const toMinutes = (value) => {
      if (!value || typeof value !== 'string' || !value.includes(':')) return 9_999;
      const [hours, minutes] = value.split(':');
      const parsedHours = Number.parseInt(hours, 10);
      const parsedMinutes = Number.parseInt(minutes, 10);
      if (Number.isNaN(parsedHours) || Number.isNaN(parsedMinutes)) return 9_999;
      return parsedHours * 60 + parsedMinutes;
    };

    const isPreviewEligiblePath = (pathname) => {
      const normalizedPathname = String(pathname || '').toLowerCase();
      return previewEligiblePathPrefixes.some((prefix) => normalizedPathname.startsWith(prefix));
    };

    const normalizePreviewUrl = (value) => {
      if (!value) return null;

      try {
        const candidateUrl = new URL(value, window.location.origin);
        if (candidateUrl.origin !== window.location.origin) return null;
        if (!isPreviewEligiblePath(candidateUrl.pathname)) return null;

        candidateUrl.hash = '';
        return candidateUrl.toString();
      } catch (error) {
        return null;
      }
    };

    const formatPreviewUrl = (value) => {
      const normalized = normalizePreviewUrl(value);
      if (!normalized) return '';

      const parsed = new URL(normalized);
      return `${parsed.pathname}${parsed.search}`;
    };

    const previewUrlFromAnchor = (anchor) => {
      if (!anchor) return null;

      const rawHref = String(anchor.getAttribute('href') || '').trim();
      if (!rawHref) return null;

      const lowerHref = rawHref.toLowerCase();
      if (
        rawHref.startsWith('#')
        || lowerHref.startsWith('mailto:')
        || lowerHref.startsWith('tel:')
        || lowerHref.startsWith('javascript:')
      ) {
        return null;
      }

      return normalizePreviewUrl(rawHref);
    };

    const resolveLegForDay = (legs, day) => {
      let runningDay = 1;
      for (const leg of legs) {
        const nights = Number(fieldValue(leg, 'nights') || 0);
        const start = runningDay;
        const end = nights > 0 ? runningDay + nights - 1 : runningDay;
        if (day >= start && day <= end) {
          return { leg, dayWithinLeg: day - start + 1 };
        }
        runningDay += nights;
      }
      return null;
    };

    const buildDayDate = (startDateRaw, day) => {
      if (!startDateRaw) return '';
      const date = new Date(startDateRaw);
      if (Number.isNaN(date.getTime())) return '';
      date.setDate(date.getDate() + (day - 1));
      return date.toLocaleDateString(undefined, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    };

    const pinLink = (pin, label) => {
      const safeLabel = escapeHtml(label || `Location PIN ${pin}`);
      if (!pin) return safeLabel;
      const normalizedPin = String(pin);
      const status = linkManifest[normalizedPin];
      const handle = pinMap[normalizedPin];
      if (!handle || (status && status !== 'found')) {
        return safeLabel;
      }
      return `<a href="/products/${handle}">${safeLabel}</a>`;
    };

    const renderInsertBlocks = (blocks) => {
      if (!Array.isArray(blocks) || blocks.length === 0) return '';

      const blockHtml = blocks.map((block) => {
        const type = String(fieldValue(block, 'type') || '').toLowerCase();
        const title = fieldValue(block, 'title') || '';
        const content = prettyText(fieldValue(block, 'content'));

        if (type === 'link_list') {
          const links = normalizeList(fieldValue(block, 'links') || []);
          const seen = new Set();
            const linkRows = links.map((linkItem) => {
            const label = fieldValue(linkItem, 'label') || '';
            const pin = fieldValue(linkItem, 'pin_id');
            const dedupeKey = String(pin || label || '').trim().toLowerCase();
              if (!dedupeKey || seen.has(dedupeKey)) return '';
              seen.add(dedupeKey);
              if (!label) return '';
              return `<li class="itin-chrono__link-item">${pin ? pinLink(pin, label) : escapeHtml(label)}</li>`;
            }).filter(Boolean).join('');

            if (!linkRows) return '';
            return `<details class="itin-chrono__insert itin-chrono__insert--links"><summary class="itin-chrono__insert-title">${escapeHtml(title || 'Related links')}</summary><ul class="itin-chrono__link-list" role="list">${linkRows}</ul></details>`;
          }

        if (!content) return '';
        return `<section class="itin-chrono__insert">${title ? `<h3 class="itin-chrono__insert-title">${escapeHtml(title)}</h3>` : ''}<div class="itin-chrono__insert-content" data-pin-links>${content}</div></section>`;
      }).filter(Boolean).join('');

      if (!blockHtml) return '';
      return `<div class="itin-chrono__inserts">${blockHtml}</div>`;
    };

    const renderCommentaryStream = (items) => {
      if (!Array.isArray(items) || items.length === 0) return '';

      const commentaryRows = items.map((item) => {
        const time = String(fieldValue(item, 'time') || '');
        const contentHtml = prettyText(fieldValue(item, 'content'));
        if (!contentHtml) return null;
        return {
          time,
          minutes: toMinutes(time),
          html: contentHtml,
        };
      }).filter(Boolean).sort((a, b) => a.minutes - b.minutes);

      if (commentaryRows.length === 0) return '';

      const rowHtml = commentaryRows.map((row) => `
        <li class="itin-chrono__commentary-item">
          ${row.time && row.time !== 'None' && row.time !== 'NotProvided' ? `<span class="itin-chrono__commentary-time">${escapeHtml(row.time)}</span>` : '<span class="itin-chrono__commentary-time"></span>'}
          <div class="itin-chrono__commentary-body" data-pin-links>${row.html}</div>
        </li>
      `).join('');

      return `<section class="itin-chrono__commentary-stream" data-pin-links><h3 class="itin-chrono__section-title">Snoop live wire</h3><ul class="itin-chrono__commentary-list" role="list">${rowHtml}</ul></section>`;
    };

    const railList = root.querySelector('.itin-chrono__rail-nav') || root.querySelector('.itin-chrono__rail-list');
    const contentRoot = root.querySelector('.itin-chrono__content');
    const previewRoot = root.querySelector('[data-chrono-preview]');
    const previewPanel = previewRoot ? previewRoot.querySelector('.itin-chrono__preview-panel') : null;
    const previewProductCard = previewRoot ? previewRoot.querySelector('[data-preview-product-card]') : null;
    const previewTitle = previewRoot ? previewRoot.querySelector('[data-preview-title]') : null;
    const previewUrlText = previewRoot ? previewRoot.querySelector('[data-preview-url]') : null;
    const previewOpen = previewRoot ? previewRoot.querySelector('[data-preview-open]') : null;
    const previewErrorOpen = previewRoot ? previewRoot.querySelector('[data-preview-error-open]') : null;
    const previewClear = previewRoot ? previewRoot.querySelector('[data-preview-clear]') : null;
    const previewViews = previewRoot ? {
      empty: previewRoot.querySelector('[data-preview-view="empty"]'),
      loading: previewRoot.querySelector('[data-preview-view="loading"]'),
      product: previewRoot.querySelector('[data-preview-view="product"]'),
      error: previewRoot.querySelector('[data-preview-view="error"]'),
    } : null;

    let activeDayObserver = null;
    let activeDayId = null;
    let activePreviewUrl = '';
    let pendingPreviewUrl = '';
    let previewLoadTimeout = null;
    let previewRequestToken = 0;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const smoothBehavior = prefersReducedMotion ? 'auto' : 'smooth';
    const themeCurrency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : '';

    const clampValue = (value, min, max) => Math.min(Math.max(value, min), max);

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(Math.round(cents));
      }

      const amount = Number(cents) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: themeCurrency || 'USD',
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2);
      }
    };

    const getStickyOffset = () => {
      const offset = Number.parseFloat(getComputedStyle(root).getPropertyValue('--itin-chrono-sticky-offset'));
      if (Number.isFinite(offset) && offset > 0) {
        return offset;
      }
      return 84;
    };

    const syncStickyOffset = () => {
      const rootStyles = getComputedStyle(document.documentElement);
      const cssHeaderHeight = Number.parseFloat(rootStyles.getPropertyValue('--header-height'));
      let measuredHeaderHeight = Number.isFinite(cssHeaderHeight) && cssHeaderHeight > 0 ? cssHeaderHeight : 0;

      const headerElement = document.querySelector('sticky-header, #shopify-section-header, .shopify-section-group-header-group');
      if (headerElement) {
        measuredHeaderHeight = Math.max(measuredHeaderHeight, headerElement.getBoundingClientRect().height || 0);
      }

      root.style.setProperty('--itin-chrono-sticky-offset', `${Math.round(measuredHeaderHeight + 24)}px`);
    };

    const scrollViewportTo = (top, behavior = smoothBehavior) => {
      window.scrollTo({
        top: Math.max(0, top),
        left: 0,
        behavior,
      });
    };

    const focusWorkspace = (behavior = smoothBehavior) => {
      const workspaceTop = window.scrollY + root.getBoundingClientRect().top - getStickyOffset() - 6;
      scrollViewportTo(workspaceTop, behavior);
    };

    const initInspectorGuestCounters = () => {
      const guestCounterRows = root.querySelectorAll('[data-inspector-guest-counter]');
      if (guestCounterRows.length === 0) return;

      for (const counterRow of guestCounterRows) {
        const panel = counterRow.closest('[data-inspector-default]');
        if (!panel) continue;

        const decreaseButton = counterRow.querySelector('[data-inspector-guest-decrease]');
        const increaseButton = counterRow.querySelector('[data-inspector-guest-increase]');
        const countEl = counterRow.querySelector('[data-inspector-guest-count]');
        const totalAmountEl = panel.querySelector('[data-inspector-price-total-amount]');
        const totalGuestsEl = panel.querySelector('[data-inspector-price-total-guests]');
        const confirmLink = panel.querySelector('[data-inspector-confirm-link]');
        if (!decreaseButton || !increaseButton || !countEl || !totalAmountEl || !totalGuestsEl) continue;

        const parsedPerGuestCents = Number.parseInt(panel.dataset.inspectorPriceCents || '0', 10);
        const perGuestCents = Number.isNaN(parsedPerGuestCents) ? 0 : parsedPerGuestCents;
        const parsedMinGuests = Number.parseInt(panel.dataset.inspectorMinGuests || '1', 10);
        const parsedMaxGuests = Number.parseInt(panel.dataset.inspectorMaxGuests || '12', 10);
        const minGuests = Number.isNaN(parsedMinGuests) ? 1 : parsedMinGuests;
        const maxGuests = Number.isNaN(parsedMaxGuests) || parsedMaxGuests < minGuests
          ? minGuests
          : parsedMaxGuests;
        const guestsTemplate = decodeEntities(panel.dataset.inspectorGuestsTemplate || '__COUNT__ guests');

        const currentCount = Number.parseInt(countEl.textContent.replace(/\D+/g, ''), 10);
        let guests = clampValue(Number.isNaN(currentCount) ? minGuests : currentCount, minGuests, maxGuests);

        const updateConfirmUrl = () => {
          if (!confirmLink) return;
          if (confirmLink.getAttribute('aria-disabled') === 'true') return;

          const baseUrl = confirmLink.dataset.inspectorConfirmBaseUrl || '';
          if (!baseUrl || baseUrl === '#') return;

          try {
            const parsedUrl = new URL(baseUrl, window.location.origin);
            parsedUrl.searchParams.set('quantity', String(guests));
            confirmLink.href = `${parsedUrl.pathname}${parsedUrl.search}`;
          } catch (error) {
            // Keep fallback href when URL parsing fails.
          }
        };

        const updateGuestText = () => {
          const template = guestsTemplate.includes('__COUNT__')
            ? guestsTemplate
            : '{{ count }} guests';
          return template
            .replace('__COUNT__', String(guests))
            .replace(/\{\{\s*count\s*\}\}/gi, String(guests));
        };

        const renderCounter = () => {
          countEl.textContent = String(guests);
          totalAmountEl.textContent = formatMoney(perGuestCents * guests);
          totalGuestsEl.textContent = updateGuestText();

          decreaseButton.disabled = guests <= minGuests;
          increaseButton.disabled = guests >= maxGuests;
          updateConfirmUrl();
        };

        decreaseButton.addEventListener('click', () => {
          guests = clampValue(guests - 1, minGuests, maxGuests);
          renderCounter();
        });

        increaseButton.addEventListener('click', () => {
          guests = clampValue(guests + 1, minGuests, maxGuests);
          renderCounter();
        });

        renderCounter();
      }
    };

    const initInspectorCustomisationLinks = () => {
      const customisationLinks = root.querySelectorAll('[data-inspector-customisation-link]');
      if (customisationLinks.length === 0) return;

      for (const link of customisationLinks) {
        link.addEventListener('click', (event) => {
          const href = String(link.getAttribute('href') || '').trim();
          if (!href.startsWith('#')) return;

          const target = document.querySelector(href);
          if (!target) return;

          event.preventDefault();
          const scrollTarget = window.scrollY + target.getBoundingClientRect().top - getStickyOffset() - 12;
          scrollViewportTo(scrollTarget, smoothBehavior);

          const hadTabindex = target.hasAttribute('tabindex');
          if (!hadTabindex) {
            target.setAttribute('tabindex', '-1');
          }
          target.focus({ preventScroll: true });
          if (!hadTabindex) {
            target.addEventListener('blur', () => {
              target.removeAttribute('tabindex');
            }, { once: true });
          }
        });
      }
    };

    const clearPreviewLoadTimeout = () => {
      if (!previewLoadTimeout) return;
      window.clearTimeout(previewLoadTimeout);
      previewLoadTimeout = null;
    };

    const previewEnabled = () => Boolean(previewRoot && previewDesktopMediaQuery.matches);

    const setPreviewPanelOpen = (isOpen) => {
      if (!previewPanel) return;
      previewPanel.dataset.previewOpen = isOpen ? 'true' : 'false';
    };

    const previewTitleFromUrl = (url, titleHint = '') => {
      if (titleHint) return titleHint;
      const normalizedUrl = normalizePreviewUrl(url);
      if (!normalizedUrl) return 'Linked page';
      const parsedUrl = new URL(normalizedUrl);
      const pathSegments = parsedUrl.pathname.split('/').filter(Boolean);
      const handle = pathSegments[pathSegments.length - 1] || '';
      if (!handle) return 'Linked page';
      return humanizeHandle(handle);
    };

    const clearProductCard = () => {
      if (!previewProductCard) return;
      previewProductCard.innerHTML = '';
    };

    const renderPageContent = (html) => {
      if (!previewProductCard) return '';
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var mainEl = doc.querySelector('#MainContent') || doc.querySelector('main') || doc.querySelector('[role="main"]');
      if (mainEl) {
        previewProductCard.innerHTML = mainEl.innerHTML;
      }
      var titleEl = doc.querySelector('title');
      var pageTitle = titleEl ? titleEl.textContent.split('\u2013')[0].split('|')[0].trim() : '';
      return pageTitle;
    };

    const updatePreviewActions = (url) => {
      const normalizedUrl = normalizePreviewUrl(url);

      [previewOpen, previewErrorOpen].forEach((linkEl) => {
        if (!linkEl) return;

        if (!normalizedUrl) {
          linkEl.removeAttribute('href');
          linkEl.setAttribute('aria-disabled', 'true');
          if (linkEl === previewOpen) {
            linkEl.tabIndex = -1;
          }
          return;
        }

        linkEl.href = normalizedUrl;
        linkEl.removeAttribute('aria-disabled');
        if (linkEl === previewOpen) {
          linkEl.removeAttribute('tabindex');
        }
      });

      if (previewClear) {
        previewClear.disabled = !normalizedUrl;
      }
    };

    const updatePreviewHeading = (titleText, urlText) => {
      if (previewTitle) {
        previewTitle.textContent = titleText || 'No page selected';
      }
      if (previewUrlText) {
        previewUrlText.textContent = urlText || 'Select an itinerary link to open it here.';
      }
    };

    const setPreviewView = (state) => {
      if (!previewPanel || !previewViews) return;

      previewPanel.dataset.previewState = state;
      Object.entries(previewViews).forEach(([viewState, viewElement]) => {
        if (!viewElement) return;
        viewElement.hidden = viewState !== state;
      });
    };

    const storePreviewSelection = (url) => {
      const currentUrl = new URL(window.location.href);
      if (url) {
        currentUrl.searchParams.set(previewQueryParam, formatPreviewUrl(url));
      } else {
        currentUrl.searchParams.delete(previewQueryParam);
      }

      const nextUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
      window.history.replaceState(window.history.state, '', nextUrl);
    };

    const readPreviewSelection = () => {
      const currentUrl = new URL(window.location.href);
      const previewValue = currentUrl.searchParams.get(previewQueryParam);
      if (!previewValue) return null;
      return normalizePreviewUrl(previewValue);
    };

    const syncActivePreviewLinks = () => {
      if (!contentRoot) return;

      const anchors = contentRoot.querySelectorAll('a');
      anchors.forEach((anchor) => {
        const isActive = previewEnabled()
          && activePreviewUrl
          && previewUrlFromAnchor(anchor) === activePreviewUrl;
        anchor.classList.toggle('is-preview-active', Boolean(isActive));
      });
    };

    const showPreviewErrorState = () => {
      clearPreviewLoadTimeout();
      pendingPreviewUrl = '';
      setPreviewPanelOpen(true);
      setPreviewView('error');
      clearProductCard();
      updatePreviewHeading('Preview unavailable', formatPreviewUrl(activePreviewUrl));
      updatePreviewActions(activePreviewUrl);
      syncActivePreviewLinks();
    };

    const loadPreviewUrl = (url, options = {}) => {
      if (!previewEnabled()) return false;

      const normalizedUrl = normalizePreviewUrl(url);
      if (!normalizedUrl) return false;

      const {
        titleHint = '',
        skipHistory = false,
      } = options;
      const requestToken = previewRequestToken + 1;
      previewRequestToken = requestToken;

      activePreviewUrl = normalizedUrl;
      pendingPreviewUrl = normalizedUrl;
      setPreviewPanelOpen(true);
      clearProductCard();
      setPreviewView('loading');
      updatePreviewHeading(previewTitleFromUrl(normalizedUrl, titleHint), formatPreviewUrl(normalizedUrl));
      updatePreviewActions(normalizedUrl);
      syncActivePreviewLinks();

      clearPreviewLoadTimeout();
      previewLoadTimeout = window.setTimeout(() => {
        if (pendingPreviewUrl === normalizedUrl && previewRequestToken === requestToken) {
          showPreviewErrorState();
        }
      }, 12000);

      if (!skipHistory) {
        storePreviewSelection(normalizedUrl);
      }

      fetch(normalizedUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          if (previewRequestToken !== requestToken) return;
          clearPreviewLoadTimeout();
          pendingPreviewUrl = '';
          var pageTitle = renderPageContent(html);
          if (previewProductCard && previewProductCard.innerHTML) {
            setPreviewView('product');
            updatePreviewHeading(pageTitle || previewTitleFromUrl(normalizedUrl), formatPreviewUrl(normalizedUrl));
            updatePreviewActions(normalizedUrl);
            syncActivePreviewLinks();
          } else {
            showPreviewErrorState();
          }
        })
        .catch(function () {
          if (previewRequestToken !== requestToken) return;
          showPreviewErrorState();
        });

      return true;
    };

    const clearPreview = (options = {}) => {
      const { skipHistory = false } = options;

      activePreviewUrl = '';
      pendingPreviewUrl = '';
      previewRequestToken += 1;
      clearPreviewLoadTimeout();
      setPreviewPanelOpen(previewEnabled());
      clearProductCard();

      setPreviewView('empty');
      updatePreviewHeading('', '');
      updatePreviewActions('');
      syncActivePreviewLinks();

      if (!skipHistory) {
        storePreviewSelection('');
      }
    };

    const restorePreviewSelection = () => {
      if (!previewEnabled()) {
        setPreviewPanelOpen(false);
        clearPreviewLoadTimeout();
        clearProductCard();
        syncActivePreviewLinks();
        return;
      }

      setPreviewPanelOpen(true);
      const persistedUrl = readPreviewSelection();
      if (!persistedUrl) {
        if (!activePreviewUrl) {
          clearPreview({ skipHistory: true });
          return;
        }

        syncActivePreviewLinks();
        return;
      }

      if (persistedUrl === activePreviewUrl && previewPanel && previewPanel.dataset.previewState === 'product') {
        syncActivePreviewLinks();
        return;
      }

      loadPreviewUrl(persistedUrl, { skipHistory: true });
    };

    const scrollToDay = (dayId, options = {}) => {
      const {
        behavior = smoothBehavior,
        updateHash = true,
        scrollRail = true,
      } = options;

      const dayCard = root.querySelector(`#day-${dayId}`);
      if (!dayCard) return;

      setActiveDay(dayId, { scrollRail });
      const dayRect = dayCard.getBoundingClientRect();
      const contentTop = contentRoot ? contentRoot.getBoundingClientRect().top : 0;
      const stickyTop = getStickyOffset() + 2;
      const alignmentTop = contentTop > stickyTop ? contentTop : stickyTop;
      const dayTop = window.scrollY + dayRect.top - alignmentTop;
      scrollViewportTo(dayTop, behavior);

      if (updateHash) {
        const nextUrl = new URL(window.location.href);
        nextUrl.hash = `day-${dayId}`;
        window.history.replaceState(window.history.state, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
      }
    };

    const setActiveDay = (dayId, options = {}) => {
      if (!dayId || dayId === activeDayId) return;

      const { scrollRail = true } = options;
      const dayCards = root.querySelectorAll('.itin-chrono__day[data-day-section]');
      const railLinks = root.querySelectorAll('.itin-chrono__rail-link');

      dayCards.forEach((card) => {
        const isActive = card.dataset.daySection === dayId;
        card.classList.toggle('is-active', isActive);
      });

      let activeLink = null;
      railLinks.forEach((link) => {
        const railDay = link.dataset.railDay || '';
        const href = link.getAttribute('href') || '';
        const isActive = railDay === dayId || href === `#day-${dayId}`;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'page');
          activeLink = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });

      if (activeLink && scrollRail) {
        activeLink.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: smoothBehavior,
        });
      }

      const mobileTabs = root.querySelectorAll('.itin-chrono__mobile-tab');
      mobileTabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.target === dayId);
      });

      activeDayId = dayId;
    };

    const initializeRailSync = () => {
      if (!railList || !contentRoot) return;

      if (activeDayObserver) {
        activeDayObserver.disconnect();
      }

      const dayCards = Array.from(root.querySelectorAll('.itin-chrono__day[data-day-section]'));
      if (!dayCards.length) return;

      const visibilityByDay = new Map();
      activeDayObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const dayId = entry.target.dataset.daySection;
          if (!dayId) return;

          if (entry.isIntersecting) {
            visibilityByDay.set(dayId, entry.intersectionRatio);
          } else {
            visibilityByDay.delete(dayId);
          }
        });

        if (visibilityByDay.size === 0) return;

        let strongestDay = null;
        let strongestRatio = 0;
        visibilityByDay.forEach((ratio, dayId) => {
          if (ratio > strongestRatio) {
            strongestRatio = ratio;
            strongestDay = dayId;
          }
        });

        if (strongestDay) {
          setActiveDay(strongestDay);
        }
      }, {
        threshold: [0.15, 0.3, 0.45, 0.6, 0.75],
        rootMargin: `${-(getStickyOffset() + 20)}px 0px -55% 0px`,
      });

      dayCards.forEach((dayCard) => activeDayObserver.observe(dayCard));

      const hashMatch = window.location.hash.match(/#day-(\d+)/);
      if (hashMatch) {
        setActiveDay(hashMatch[1], { scrollRail: false });
      } else {
        const firstDay = dayCards[0].dataset.daySection;
        if (firstDay) {
          setActiveDay(firstDay, { scrollRail: false });
        }
      }
    };

    if (previewOpen) {
      previewOpen.addEventListener('click', (event) => {
        if (previewOpen.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
        }
      });
    }

    if (previewClear) {
      previewClear.addEventListener('click', () => {
        clearPreview();
      });
    }

    root.addEventListener('click', (event) => {
      const railLink = event.target.closest('.itin-chrono__rail-link');
      if (!railLink) return;

      if (
        event.defaultPrevented
        || event.button !== 0
        || event.metaKey
        || event.ctrlKey
        || event.shiftKey
        || event.altKey
      ) {
        return;
      }

      const dayMatch = (railLink.getAttribute('href') || '').match(/#day-(\d+)/);
      if (!dayMatch) return;

      event.preventDefault();
      scrollToDay(dayMatch[1], {
        behavior: smoothBehavior,
        updateHash: true,
        scrollRail: false,
      });
    });

    if (contentRoot) {
      contentRoot.addEventListener('click', (event) => {
        const targetLink = event.target.closest('a');
        if (!targetLink || !contentRoot.contains(targetLink)) return;
        if (!previewEnabled()) return;

        if (
          event.defaultPrevented
          || event.button !== 0
          || event.metaKey
          || event.ctrlKey
          || event.shiftKey
          || event.altKey
          || targetLink.hasAttribute('download')
        ) {
          return;
        }

        const targetAttr = String(targetLink.getAttribute('target') || '').toLowerCase();
        if (targetAttr && targetAttr !== '_blank' && targetAttr !== '_self') {
          return;
        }

        const previewUrl = previewUrlFromAnchor(targetLink);
        if (!previewUrl) return;

        event.preventDefault();
        focusWorkspace();
        const linkTitle = targetLink.textContent.replace(/\s+/g, ' ').trim();
        loadPreviewUrl(previewUrl, { titleHint: linkTitle });
      });
    }

    window.addEventListener('hashchange', () => {
      const hashMatch = window.location.hash.match(/#day-(\d+)/);
      if (!hashMatch) return;

      window.requestAnimationFrame(() => {
        scrollToDay(hashMatch[1], {
          behavior: 'auto',
          updateHash: false,
          scrollRail: true,
        });
      });
    });

    const handlePreviewViewportChange = () => {
      if (!previewEnabled()) {
        setPreviewPanelOpen(false);
        syncActivePreviewLinks();
        return;
      }

      restorePreviewSelection();
    };

    if (typeof previewDesktopMediaQuery.addEventListener === 'function') {
      previewDesktopMediaQuery.addEventListener('change', handlePreviewViewportChange);
    } else if (typeof previewDesktopMediaQuery.addListener === 'function') {
      previewDesktopMediaQuery.addListener(handlePreviewViewportChange);
    }

    window.addEventListener('resize', () => {
      syncStickyOffset();
      initializeRailSync();
    });

    const initLegToggles = () => {
      root.querySelectorAll('.itin-chrono__leg-header[data-leg-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const legId = btn.dataset.legToggle;
          const container = root.querySelector(`#${legId}`);
          if (!container) return;
          const isCollapsed = container.classList.toggle('is-collapsed');
          btn.setAttribute('aria-expanded', String(!isCollapsed));
        });
      });
    };

    const initMobilePicker = () => {
      const picker = root.querySelector('.itin-chrono__mobile-picker');
      if (!picker) return;

      const dayCards = root.querySelectorAll('.itin-chrono__day[data-day-section]');
      dayCards.forEach((dayCard) => {
        const dayId = dayCard.dataset.daySection;
        const titleEl = dayCard.querySelector('.itin-chrono__day-title');
        const label = titleEl ? titleEl.textContent.trim() : `Day ${dayId}`;
        const tab = document.createElement('div');
        tab.className = 'itin-chrono__mobile-tab';
        tab.dataset.target = dayId;
        tab.textContent = label;
        tab.addEventListener('click', () => {
          scrollToDay(dayId, { behavior: smoothBehavior, updateHash: true, scrollRail: false });
          picker.querySelectorAll('.itin-chrono__mobile-tab').forEach((t) => t.classList.remove('is-active'));
          tab.classList.add('is-active');
        });
        picker.appendChild(tab);
      });
    };

    const initBottomSheet = () => {
      const overlay = root.querySelector('[data-bottom-sheet-overlay]');
      if (!overlay) return;

      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
          overlay.classList.remove('is-open');
        }
      });
    };

    syncStickyOffset();
    applyPinLinks();
    normalizeRouteLocationLabels(root);
    formatSnoopNarrative(root);
    injectNarrativeCues(root);
    suppressRunSheetWhenLiveWirePresent(root);
    applyPinLinks(root);
    initLegToggles();
    initMobilePicker();
    initBottomSheet();
    initInspectorGuestCounters();
    initInspectorCustomisationLinks();
    initializeRailSync();
    restorePreviewSelection();

    const initialHashMatch = window.location.hash.match(/#day-(\d+)/);
    if (initialHashMatch) {
      window.requestAnimationFrame(() => {
        scrollToDay(initialHashMatch[1], {
          behavior: 'auto',
          updateHash: false,
          scrollRail: false,
        });
      });
    }

    const chronologySource = root.dataset.chronologySource || '';
    const existingDayCount = root.querySelectorAll('.itin-chrono__day').length;
    const canonicalPayloadUrl = root.dataset.itinerarySourceJsonCdnUrl || '';

    if (chronologySource === 'itinerary_source_json_inline' && existingDayCount > 0) {
      return;
    }

    if (!railList || !contentRoot || !canonicalPayloadUrl) {
      return;
    }

    const renderFromPayload = (payload) => {
      const legs = [...(payload.legs || [])].sort((a, b) => Number(fieldValue(a, 'sequence') || 0) - Number(fieldValue(b, 'sequence') || 0));
      const routes = [...(payload.routes || [])].sort((a, b) => Number(fieldValue(a, 'sequence') || 0) - Number(fieldValue(b, 'sequence') || 0));
      const totalDays = Number(payload.days || 0);
      if (!totalDays || legs.length === 0) {
        return false;
      }

      const startDate = fieldValue(payload, 'start_date');
      railList.innerHTML = '';
      contentRoot.innerHTML = '';

      for (let day = 1; day <= totalDays; day += 1) {
        const legInfo = resolveLegForDay(legs, day);
        if (!legInfo) continue;

        const { leg, dayWithinLeg } = legInfo;
        const periods = fieldValue(leg, 'periods') || [];
        const period = periods[dayWithinLeg - 1] || (periods.length === 1 ? periods[0] : null);
        const activities = period ? normalizeActivities(period) : [];
        const commentaryItems = period ? normalizeCommentaryItems(period) : [];
        const insertBlocks = period ? normalizeInsertBlocks(period) : [];
        const checkIn = String(fieldValue(leg, 'check_in_time') || '');
        const checkOut = String(fieldValue(leg, 'check_out_time') || '');
        const accName = fieldValue(leg, 'accommodation_name') || '';
        const destName = fieldValue(leg, 'destination_name') || '';

        const dayRoutes = routes.filter((route) => {
          const startDay = Number(fieldValue(route, 'start_day') || 0);
          const endDay = Number(fieldValue(route, 'end_day') || startDay);
          return startDay === day || endDay === day;
        });

        const timelineRows = [];
        if (checkIn && checkIn !== 'None' && checkIn !== 'NotProvided' && dayWithinLeg === 1) {
          timelineRows.push({
            type: 'context',
            time: checkIn,
            minutes: toMinutes(checkIn),
            rank: 10,
            body: `Check-in${accName ? `: ${escapeHtml(accName)}` : ''}`,
          });
        }

        dayRoutes.forEach((route) => {
          const startPin = fieldValue(route, 'start_content_entity_id');
          const endPin = fieldValue(route, 'end_content_entity_id');
          const startName = fieldValue(route, 'start_location') || `Location PIN ${startPin}`;
          const endName = fieldValue(route, 'end_location') || `Location PIN ${endPin}`;
          const time = String(fieldValue(route, 'start_time') || '');
          const mode = fieldValue(route, 'mode') || 'Transfer';
          const modeLabel = fieldValue(route, 'label') || '';
          timelineRows.push({
            type: 'route',
            time,
            minutes: toMinutes(time),
            rank: 20,
            body: `<span class="itin-chrono__timeline-chip">${escapeHtml(humanizeRouteMode(mode, modeLabel))}</span><span class="itin-chrono__timeline-route">${pinLink(startPin, startName)} &rarr; ${pinLink(endPin, endName)}</span>`,
          });
        });

        activities.forEach((activity) => {
          const pin = fieldValue(activity, 'content_entity_id');
          const name = fieldValue(activity, 'name') || (pin ? `PIN ${pin}` : 'Activity');
          const time = String(fieldValue(activity, 'start_time') || fieldValue(activity, 'end_time') || '');
          timelineRows.push({
            type: 'activity',
            time,
            minutes: toMinutes(time),
            rank: 30,
            body: pin ? pinLink(pin, name) : escapeHtml(name),
          });
        });

        const legType = String(fieldValue(leg, 'type') || '').toLowerCase();
        if (checkOut && checkOut !== 'None' && checkOut !== 'NotProvided' && (legType === 'departure' || day === totalDays)) {
          timelineRows.push({
            type: 'context',
            time: checkOut,
            minutes: toMinutes(checkOut),
            rank: 40,
            body: `Check-out${accName ? `: ${escapeHtml(accName)}` : ''}`,
          });
        }

        timelineRows.sort((a, b) => {
          const minuteDiff = a.minutes - b.minutes;
          if (minuteDiff !== 0) return minuteDiff;
          return (a.rank || 99) - (b.rank || 99);
        });

        const railDate = buildDayDate(startDate, day);
        const railItem = document.createElement('li');
        railItem.className = 'itin-chrono__rail-item';
        railItem.innerHTML = `<a href="#day-${day}" class="itin-chrono__rail-link"><span class="itin-chrono__rail-day">Day ${day}</span>${railDate ? `<span class="itin-chrono__rail-date">${escapeHtml(railDate)}</span>` : ''}</a>`;
        railList.appendChild(railItem);

        const narrativeRaw = period ? fieldValue(period, 'day_narrative') || fieldValue(period, 'consultant_notes') : '';
        const consultantRaw = period ? fieldValue(period, 'consultant_notes') : '';
        const includedRaw = period ? fieldValue(period, 'included') : '';
        const notesRaw = period ? fieldValue(period, 'notes') : '';
        const narrativeHtml = prettyText(narrativeRaw);
        const consultantHtml = prettyText(consultantRaw);
        const includedHtml = prettyText(includedRaw);
        const notesHtml = prettyText(notesRaw);
        const insertBlocksHtml = renderInsertBlocks(insertBlocks);
        const commentaryStreamHtml = renderCommentaryStream(commentaryItems);
        const dayDateDisplay = buildDayDate(startDate, day);

        const article = document.createElement('article');
        article.className = 'itin-chrono__day';
        article.id = `day-${day}`;
        article.setAttribute('data-day-section', String(day));
        const transitionNote = dayRoutes.length > 0
          ? `<p class="itin-chrono__transition-note">Inter-leg transition · ${dayRoutes.length} segment${dayRoutes.length === 1 ? '' : 's'}</p>`
          : '';
        article.innerHTML = `
          <header class="itin-chrono__day-header">
            <div class="itin-chrono__day-meta">
              <span class="itin-chrono__day-number">Day ${day}</span>
              ${dayDateDisplay ? `<span class="itin-chrono__day-date">${escapeHtml(dayDateDisplay)}</span>` : ''}
            </div>
            ${destName ? `<div class="itin-chrono__day-destination">${escapeHtml(destName)}</div>` : ''}
          </header>
          ${timelineRows.length > 0 ? `<section class="itin-chrono__timeline">${transitionNote}<ul class="itin-chrono__timeline-list" role="list">${timelineRows.map((row) => `<li class="itin-chrono__timeline-item${row.type === 'context' ? ' itin-chrono__timeline-item--context' : ''}">${row.time && row.time !== 'None' && row.time !== 'NotProvided' ? `<span class="itin-chrono__timeline-time">${escapeHtml(row.time)}</span>` : '<span></span>'}<span class="itin-chrono__timeline-text">${row.body}</span></li>`).join('')}</ul></section>` : ''}
          ${commentaryStreamHtml}
          ${narrativeHtml ? `<div class="itin-chrono__narrative" data-pin-links>${narrativeHtml}</div>` : ''}
          ${insertBlocksHtml}
          ${notesHtml ? `<details class="itin-chrono__notes" data-pin-links open><summary>Day notes</summary><div class="itin-chrono__notes-body">${notesHtml}</div></details>` : ''}
          ${includedHtml ? `<details class="itin-chrono__notes" data-pin-links><summary>Included today</summary><div class="itin-chrono__notes-body">${includedHtml}</div></details>` : ''}
          ${consultantHtml ? `<details class="itin-chrono__notes" data-pin-links open><summary>Consultant notes</summary><div class="itin-chrono__notes-body">${consultantHtml}</div></details>` : ''}
        `;
        contentRoot.appendChild(article);
      }

      applyPinLinks(contentRoot);
      normalizeRouteLocationLabels(contentRoot);
      formatSnoopNarrative(contentRoot);
      injectNarrativeCues(contentRoot);
      suppressRunSheetWhenLiveWirePresent(contentRoot);
      applyPinLinks(contentRoot);
      initializeRailSync();
      restorePreviewSelection();
      return contentRoot.querySelector('.itin-chrono__day') !== null;
    };

    const fetchAndRenderCanonicalPayload = async () => {
      try {
        const response = await fetch(canonicalPayloadUrl, { credentials: 'omit' });
        if (!response.ok) return;

        const payload = await response.json();
        renderFromPayload(payload);
      } catch (error) {
        // Canonical payload fetch failed; leave chronology empty.
      }
    };

    fetchAndRenderCanonicalPayload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wetu-journey-overview"] && !Shopify.designMode) return;
  try {
    
  class JourneyOverview {
    constructor(section) {
      this.section = section;
      this.timeline = section.querySelector('.wetu-journey-overview__timeline');
      this.dayCards = section.querySelectorAll('.wetu-journey-overview__day');
      this.progressFill = section.querySelector('.progress-bar__fill');
      this.progressCurrent = section.querySelector('.progress-current');
      this.prevArrow = section.querySelector('.wetu-journey-overview__arrow--prev');
      this.nextArrow = section.querySelector('.wetu-journey-overview__arrow--next');
      
      if (!this.timeline) return;
      
      this.init();
    }

    init() {
      this.bindClickHandlers();
      this.bindScrollHandler();
      this.bindArrowHandlers();
      this.updateArrowVisibility();
      this.observeDaySections();
    }

    bindClickHandlers() {
      this.dayCards.forEach(card => {
        const button = card.querySelector('.wetu-journey-overview__day-card');
        if (!button || button.classList.contains('wetu-journey-overview__day-card--end')) return;

        button.addEventListener('click', () => {
          const targetId = button.dataset.scrollTo;
          const targetSection = document.getElementById(targetId) || 
                               document.querySelector(`[data-day="${card.dataset.day}"]`);
          
          if (targetSection) {
            const headerOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || 80);
            const stickyOffset = this.section.classList.contains('wetu-journey-overview--sticky') ? this.section.offsetHeight : 0;
            const totalOffset = headerOffset + stickyOffset + 20;
            
            const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - totalOffset;
            
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    }

    bindScrollHandler() {
      this.timeline.addEventListener('scroll', () => {
        this.updateArrowVisibility();
      }, { passive: true });
    }

    bindArrowHandlers() {
      if (!this.prevArrow || !this.nextArrow) return;

      const scrollAmount = 200;

      this.prevArrow.addEventListener('click', () => {
        this.timeline.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      this.nextArrow.addEventListener('click', () => {
        this.timeline.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    updateArrowVisibility() {
      if (!this.prevArrow || !this.nextArrow) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.timeline;
      const threshold = 10;

      this.prevArrow.hidden = scrollLeft <= threshold;
      this.nextArrow.hidden = scrollLeft + clientWidth >= scrollWidth - threshold;
    }

    observeDaySections() {
      // Find all day sections in the day-by-day section
      const daySections = document.querySelectorAll('.timeline-day[data-day], .day-card[data-day]');
      if (!daySections.length) return;

      const observerOptions = {
        root: null,
        rootMargin: '-30% 0px -60% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const dayNumber = entry.target.dataset.day;
            this.setActiveDay(dayNumber);
          }
        });
      }, observerOptions);

      daySections.forEach(section => observer.observe(section));
    }

    setActiveDay(dayNumber) {
      // Update active state
      this.dayCards.forEach(card => {
        const cardDay = parseInt(card.dataset.day);
        const isActive = cardDay === parseInt(dayNumber);
        card.classList.toggle('wetu-journey-overview__day--active', isActive);
        
        if (isActive) {
          // Scroll card into view in the timeline
          this.scrollCardIntoView(card);
        }
      });

      // Update progress
      const activeIndex = Array.from(this.dayCards).findIndex(card => 
        card.classList.contains('wetu-journey-overview__day--active')
      );
      
      if (activeIndex >= 0 && this.progressFill && this.progressCurrent) {
        const total = this.dayCards.length - 1; // Exclude end marker
        const progress = ((activeIndex + 1) / total) * 100;
        this.progressFill.style.width = `${progress}%`;
        this.progressCurrent.textContent = activeIndex + 1;
      }
    }

    scrollCardIntoView(card) {
      if (!this.timeline) return;

      const cardRect = card.getBoundingClientRect();
      const timelineRect = this.timeline.getBoundingClientRect();
      
      if (cardRect.left < timelineRect.left) {
        this.timeline.scrollBy({
          left: cardRect.left - timelineRect.left - 16,
          behavior: 'smooth'
        });
      } else if (cardRect.right > timelineRect.right) {
        this.timeline.scrollBy({
          left: cardRect.right - timelineRect.right + 16,
          behavior: 'smooth'
        });
      }
    }
  }

  // Initialize
  document.querySelectorAll('.wetu-journey-overview').forEach(section => {
    new JourneyOverview(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wetu-media-gallery"] && !Shopify.designMode) return;
  try {
    
  class WetuMediaGallery {
    constructor(section) {
      this.section = section;
      this.grid = section.querySelector('.wetu-gallery__grid');
      this.tabs = section.querySelectorAll('.wetu-gallery__tab');
      this.tabContents = section.querySelectorAll('[data-tab-content]');
      this.loadMoreBtn = section.querySelector('[data-load-more]');
      this.hiddenItems = section.querySelector('.wetu-gallery__hidden-items');
      this.lightbox = section.querySelector('.wetu-lightbox');
      
      this.currentIndex = 0;
      this.images = [];
      
      this.init();
    }

    init() {
      this.collectImages();
      this.setupTabs();
      this.setupLoadMore();
      this.setupLightbox();
      this.setupVideoTriggers();
    }

    collectImages() {
      this.images = Array.from(this.section.querySelectorAll('[data-lightbox-trigger]')).map(trigger => ({
        src: trigger.dataset.fullSrc,
        caption: trigger.dataset.caption,
        property: trigger.dataset.property
      }));
    }

    setupTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const tabName = tab.dataset.tab;
          
          // Update tab states
          this.tabs.forEach(t => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          
          // Filter items or show tab content
          if (tabName === 'all') {
            this.grid.hidden = false;
            this.section.querySelector('.wetu-gallery__panoramas')?.setAttribute('hidden', '');
            this.filterItems('all');
          } else if (tabName === 'photos') {
            this.grid.hidden = false;
            this.section.querySelector('.wetu-gallery__panoramas')?.setAttribute('hidden', '');
            this.filterItems('photo');
          } else if (tabName === 'videos') {
            this.grid.hidden = false;
            this.section.querySelector('.wetu-gallery__panoramas')?.setAttribute('hidden', '');
            this.filterItems('video');
          } else if (tabName === 'tours') {
            this.grid.hidden = true;
            this.section.querySelector('.wetu-gallery__panoramas')?.removeAttribute('hidden');
          }
        });
      });
    }

    filterItems(type) {
      const items = this.grid.querySelectorAll('.wetu-gallery__item');
      items.forEach(item => {
        if (type === 'all' || item.dataset.type === type) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    }

    setupLoadMore() {
      if (!this.loadMoreBtn || !this.hiddenItems) return;
      
      this.loadMoreBtn.addEventListener('click', () => {
        const items = this.hiddenItems.querySelectorAll('.wetu-gallery__item');
        items.forEach(item => {
          this.grid.appendChild(item.cloneNode(true));
        });
        
        // Re-collect images and setup lightbox triggers
        this.collectImages();
        this.setupLightboxTriggers();
        
        // Hide load more button and hidden container
        this.loadMoreBtn.parentElement.style.display = 'none';
        this.hiddenItems.remove();
      });
    }

    setupLightbox() {
      if (!this.lightbox) return;
      
      this.lightboxImage = this.lightbox.querySelector('.lightbox__image');
      this.lightboxVideo = this.lightbox.querySelector('.lightbox__video');
      this.lightboxVideoContainer = this.lightbox.querySelector('.lightbox__video-container');
      this.lightboxCaption = this.lightbox.querySelector('.lightbox__caption');
      this.lightboxCounter = this.lightbox.querySelector('.lightbox__counter');
      this.closeBtn = this.lightbox.querySelector('.lightbox__close');
      this.prevBtn = this.lightbox.querySelector('.lightbox__nav--prev');
      this.nextBtn = this.lightbox.querySelector('.lightbox__nav--next');
      this.backdrop = this.lightbox.querySelector('.lightbox__backdrop');
      
      this.setupLightboxTriggers();
      
      this.closeBtn?.addEventListener('click', () => this.closeLightbox());
      this.backdrop?.addEventListener('click', () => this.closeLightbox());
      this.prevBtn?.addEventListener('click', () => this.navigate(-1));
      this.nextBtn?.addEventListener('click', () => this.navigate(1));
      
      document.addEventListener('keydown', (e) => {
        if (this.lightbox.hidden) return;
        if (e.key === 'Escape') this.closeLightbox();
        if (e.key === 'ArrowLeft') this.navigate(-1);
        if (e.key === 'ArrowRight') this.navigate(1);
      });
    }

    setupLightboxTriggers() {
      this.section.querySelectorAll('[data-lightbox-trigger]').forEach((trigger, index) => {
        trigger.addEventListener('click', () => this.openLightbox(index));
      });
    }

    openLightbox(index) {
      this.currentIndex = index;
      this.updateLightbox();
      this.lightbox.hidden = false;
      this.lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    closeLightbox() {
      this.lightbox.hidden = true;
      this.lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      
      // Stop video if playing
      if (this.lightboxVideo) {
        this.lightboxVideo.src = '';
      }
    }

    navigate(direction) {
      this.currentIndex = (this.currentIndex + direction + this.images.length) % this.images.length;
      this.updateLightbox();
    }

    updateLightbox() {
      const image = this.images[this.currentIndex];
      if (!image) return;
      
      this.lightboxImage.src = image.src;
      this.lightboxImage.alt = image.caption || '';
      this.lightboxCaption.textContent = image.caption || image.property || '';
      this.lightboxCounter.textContent = `${this.currentIndex + 1} / ${this.images.length}`;
      
      // Show image, hide video
      this.lightboxImage.hidden = false;
      if (this.lightboxVideoContainer) {
        this.lightboxVideoContainer.hidden = true;
      }
    }

    setupVideoTriggers() {
      this.section.querySelectorAll('[data-video-trigger]').forEach(trigger => {
        trigger.addEventListener('click', () => {
          const embedUrl = trigger.dataset.embed;
          const title = trigger.dataset.title;
          
          if (!embedUrl || !this.lightbox) return;
          
          // Show video in lightbox
          this.lightboxImage.hidden = true;
          this.lightboxVideoContainer.hidden = false;
          this.lightboxVideo.src = embedUrl + '?autoplay=1';
          this.lightboxCaption.textContent = title || '';
          this.lightboxCounter.textContent = '';
          
          this.lightbox.hidden = false;
          this.lightbox.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const gallerySection = document.querySelector('[data-section-type="media-gallery"]');
    if (gallerySection) {
      new WetuMediaGallery(gallerySection);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
